import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import homeIcon from "./assets/home.png";
import gestioneParcoAutoIcon from "./assets/gestione parco auto.png";
import documentiPersonaliIcon from "./assets/documenti personali.png";
import carteBancarieIcon from "./assets/carte bancarie.png";
import casaImmobiliIcon from "./assets/casa e immobili.png";
import protezionePersonaleIcon from "./assets/protezione personale e familiare.png";
import fiscoTributiIcon from "./assets/fisco e tributi.png";
import identitaDigitaleIcon from "./assets/identità digitale.png";
import previdenzaIcon from "./assets/previdenza investimenti debiti.png";
import saluteIcon from "./assets/salute e prevenzione.png";
import mobilitaIcon from "./assets/mobilità.png";
import animaliIcon from "./assets/animali domestici.png";
import varieIcon from "./assets/varie.png";
import gestioneDocumentiIcon from "./assets/gestione documenti.png";
import guidaIcon from "./assets/guida agenda scadenze.png";
import cartellaBlu from "./assets/cartella-blu.png";
import logoAingegnerIA from "./assets/logoaingegneria.png";
import iconDataOra from "./assets/data_ora.png";
import iconProfilo from "./assets/icona_profilo.png";
import iconLogout from "./assets/icona_logout.png";
import ImpiantiPage from "./components/ImpiantiPage";
import CustomerDetailHeader from "./components/customers/CustomerDetailHeader";
import CustomerKpiPanel from "./components/customers/CustomerKpiPanel";
import CustomerPlantsPanel from "./components/customers/CustomerPlantsPanel";
import CustomerTimeline from "./components/customers/CustomerTimeline";
import DashboardPage from "./components/DashboardPage";
import CalendarPage from "./components/CalendarPage";
import StatisticsPage from "./components/StatisticsPage";
import API, { authFetch } from "./services/api";

import "./ui/buttons.css";
import {
  cardStyle,
  compactCardStyle,
  pageTitleStyle,
  pageSubtitleStyle,
  sectionTitleStyle,
  primaryButtonStyle,
  secondaryButtonStyle,
  dangerButtonStyle,
  inputStyle,
  searchInputStyle,
  emptyBoxStyle,
  tableStyle,
  tableHeaderRowStyle,
  thStyle,
  tdStyle,
  rowStyle,
  colors,
} from "./ui/styles";

const iconeSidebar = {
  Home: homeIcon,
  "Clienti": gestioneParcoAutoIcon,
  "Impianti": gestioneParcoAutoIcon,
  "Documenti personali": documentiPersonaliIcon,
  "Carte bancarie": carteBancarieIcon,
  "Casa e immobili": casaImmobiliIcon,
  "Protezione personale e familiare": protezionePersonaleIcon,
  "Fisco e Tributi": fiscoTributiIcon,
  "Identità digitale": identitaDigitaleIcon,
  "Previdenza Investimenti Debiti": previdenzaIcon,
  "Salute e prevenzione": saluteIcon,
  Mobilità: mobilitaIcon,
  "Animali domestici": animaliIcon,
  Varie: varieIcon,
  "Gestione documenti": gestioneDocumentiIcon,
  Guida: guidaIcon,
};

function App() {
  const [data, setData] = useState(null);
  const [errore, setErrore] = useState("");
  const [loading, setLoading] = useState(true);
  const [sezione, setSezione] = useState(() => {
  const savedUser = localStorage.getItem("utenteCorrente");

  return savedUser ? "home" : "login";
});

  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [hoveredButton, setHoveredButton] = useState("");
  const [categoriaAttiva, setCategoriaAttiva] = useState("Documenti personali");
  const [tabAttivoDocumenti, setTabAttivoDocumenti] = useState("inserisci");
  const [documentiFile, setDocumentiFile] = useState({});
  const [cartellaAperta, setCartellaAperta] = useState(null);
  const [eliminaModalita, setEliminaModalita] = useState("singola");
  const [eliminaMetodo, setEliminaMetodo] = useState("");
  const [eliminaDestinazione, setEliminaDestinazione] = useState("");
  const [eliminaIntestatario, setEliminaIntestatario] = useState("");
  const [eliminaTipologia, setEliminaTipologia] = useState("");
  const [eliminaDocumentoId, setEliminaDocumentoId] = useState("");
  const [clienteSelezionato, setClienteSelezionato] = useState(null);
  const [vistaDettaglioCliente, setVistaDettaglioCliente] = useState(false);
  const [impiantiCliente, setImpiantiCliente] = useState([]);
  const [interventiCliente, setInterventiCliente] = useState([]);
  const [scadenzeCliente, setScadenzeCliente] = useState([]);
  const [impiantoDaAprireId, setImpiantoDaAprireId] = useState(null);
  const [origineAperturaImpianto, setOrigineAperturaImpianto] = useState("impianti");
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(false);
  const notificationDropdownRef = useRef(null);

  const [searchQuery, setSearchQuery] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showSearchResults, setShowSearchResults] = useState(false);

  const [cercaModalita, setCercaModalita] = useState("singola");
  const [cercaMetodo, setCercaMetodo] = useState("");
  const [cercaDestinazione, setCercaDestinazione] = useState("");
  const [cercaIntestatario, setCercaIntestatario] = useState("");
  const [cercaTipologia, setCercaTipologia] = useState("");
  const [ricercaTestoDocumento, setRicercaTestoDocumento] = useState("");

const [nuovoDocumentoFile, setNuovoDocumentoFile] = useState({
  scadenzaId: null,
  intestatario: "",
  destinazione: "",
  tipoDocumento: "",
  tipoAltro: "",
  file: null,
});

const [documentoFileSelezionatoId, setDocumentoFileSelezionatoId] = useState("");
const [ricercaDocumentoFile, setRicercaDocumentoFile] = useState("");
const [vistaArchivioDocumenti, setVistaArchivioDocumenti] = useState("destinazione");
const [archivioDestinazione, setArchivioDestinazione] = useState("");
const [archivioIntestatario, setArchivioIntestatario] = useState("");
const [archivioTipologia, setArchivioTipologia] = useState("");
const [utenteCorrente, setUtenteCorrente] = useState(() => {
  const savedUser = localStorage.getItem("utenteCorrente");

  return savedUser ? JSON.parse(savedUser) : null;
});
const isAdmin = utenteCorrente?.role === "admin";
const isTechnician = utenteCorrente?.role === "technician";
const isViewer = utenteCorrente?.role === "viewer";
const [clienti, setClienti] = useState([]);

const [mostraNuovoCliente, setMostraNuovoCliente] = useState(false);

const [clienteInModifica, setClienteInModifica] = useState(null);
const [mostraModificaCliente, setMostraModificaCliente] = useState(false);

const [nuovoCliente, setNuovoCliente] = useState({
  first_name: "",
  last_name: "",
  company_name: "",
  customer_type: "",
  customer_category: "",
  fiscal_code: "",
  vat_number: "",
  pec: "",
  sdi_code: "",
  phone: "",
  email: "",
  address: "",
  city: "",
  province: "",
  postal_code: "",
  notes: "",
});

const [loginForm, setLoginForm] = useState({
  email: "",
  password: "",
});

const [mostraLoginPassword, setMostraLoginPassword] = useState(false);
const [fileInputKey, setFileInputKey] = useState(Date.now());
const [mostraCaricaDocumento, setMostraCaricaDocumento] = useState(false);
const [prefillDocumento, setPrefillDocumento] = useState(null);
const [passwordForm, setPasswordForm] = useState({
  attuale: "",
  nuova: "",
  conferma: "",
});

const [mostraPassword, setMostraPassword] = useState({
  attuale: false,
  nuova: false,
  conferma: false,
});

const utentiDemo = [
  {
    email: "gabriele@demo.it",
    password: "1234",
    nome: "Gabriele Niro",
    idUtente: 1,
  },
  {
    email: "giovanni@demo.it",
    password: "1234",
    nome: "Giovanni Niro",
    idUtente: 2,
  },
  {
    email: "maria@demo.it",
    password: "1234",
    nome: "Maria Grazia",
    idUtente: 3,
  },
];

  useEffect(() => {
  const savedCategoria = localStorage.getItem("categoriaAttiva");
  const savedSidebarOpen = localStorage.getItem("sidebarOpen");
  const savedUtente = localStorage.getItem("utenteCorrente");
  const savedToken = localStorage.getItem("token");

  if (savedCategoria) setCategoriaAttiva(savedCategoria);
  if (savedSidebarOpen !== null) setSidebarOpen(savedSidebarOpen === "true");

  if (savedUtente && savedToken) {
    setUtenteCorrente(JSON.parse(savedUtente));
    setSezione("home");
  } else {
    setSezione("login");
  }
}, []);

  useEffect(() => {
    localStorage.setItem("sezione", sezione);
    localStorage.setItem("categoriaAttiva", categoriaAttiva);
    localStorage.setItem("sidebarOpen", String(sidebarOpen));
  }, [sezione, categoriaAttiva, sidebarOpen]);

  useEffect(() => {
  const saved = localStorage.getItem("documentiFile");

  if (saved) {
    setDocumentiFile(JSON.parse(saved));
  }
}, []);

useEffect(() => {
  if (!documentiFile || Object.keys(documentiFile).length === 0) return;

  localStorage.setItem("documentiFile", JSON.stringify(documentiFile));
}, [documentiFile]);

useEffect(() => {
  if (utenteCorrente) {
    localStorage.setItem("utenteCorrente", JSON.stringify(utenteCorrente));
  } else {
    localStorage.removeItem("utenteCorrente");
  }
}, [utenteCorrente]);

useEffect(() => {
  const timer = setInterval(() => {
    setNow(new Date());
  }, 1000);

  return () => clearInterval(timer);
}, []);

useEffect(() => {
  const handleClickOutsideNotifications = (event) => {
    if (
      notificationDropdownRef.current &&
      !notificationDropdownRef.current.contains(event.target)
    ) {
      setShowNotifications(false);
    }
  };

  const handleEscNotifications = (event) => {
    if (event.key === "Escape") {
      setShowNotifications(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutsideNotifications);
  document.addEventListener("keydown", handleEscNotifications);

  return () => {
    document.removeEventListener("mousedown", handleClickOutsideNotifications);
    document.removeEventListener("keydown", handleEscNotifications);
  };
}, []);

useEffect(() => {
  if (
    prefillDocumento &&
    sezione === "gestione_documenti" &&
    tabAttivoDocumenti === "inserisci"
  ) {
    setNuovoDocumentoFile((prev) => ({
  ...prev,
  scadenzaId: prefillDocumento.scadenzaId || null,
  intestatario: prefillDocumento.intestatario || "",
  destinazione: prefillDocumento.destinazione || "",
  tipoDocumento: prefillDocumento.tipoDocumento || "",
  tipoAltro: "",
  file: null,
}));

    setPrefillDocumento(null);
  }
}, [prefillDocumento, sezione, tabAttivoDocumenti]);

const caricaClienti = async () => {
  try {
    const response = await authFetch(
      "/api/customers/"
    );

    if (!response.ok) {
      throw new Error("Errore caricamento clienti");
    }

    const data = await response.json();

    setClienti(data);
  } catch (err) {
    console.error(err);
  }
};

const apriSchedaCliente = async (cliente) => {
  setClienteSelezionato(cliente);
  setVistaDettaglioCliente(true);

  setImpiantiCliente([]);
  setInterventiCliente([]);
  setScadenzeCliente([]);

  try {
    const response = await authFetch(
      "/api/plants/"
    );

    if (!response.ok) {
      throw new Error("Errore caricamento impianti cliente");
    }

    const data = await response.json();

    const impiantiDelCliente = data.filter(
      (impianto) => impianto.customer_id === cliente.id
    );

    setImpiantiCliente(impiantiDelCliente);

    if (impiantiDelCliente.length === 0) {
      return;
    }

    const risultati = await Promise.all(
      impiantiDelCliente.map(async (impianto) => {
        const [
          interventiRes,
          manutenzioniRes,
          scadenzeRes,
        ] = await Promise.all([
          authFetch(
            `/api/interventions/plant/${impianto.id}`
          ),
          authFetch(
            `/api/maintenance-plans/plant/${impianto.id}`
          ),
          authFetch(
            `/api/technical-deadlines/plant/${impianto.id}`
          ),
        ]);

        const interventi = interventiRes.ok
          ? await interventiRes.json()
          : [];

        const manutenzioni = manutenzioniRes.ok
          ? await manutenzioniRes.json()
          : [];

        const scadenzeTecniche = scadenzeRes.ok
          ? await scadenzeRes.json()
          : [];

        return {
          interventi,
          scadenze: [
            ...manutenzioni.filter(
              (item) =>
                item.status !== "Completato" &&
                item.status !== "Completata"
            ),
            ...scadenzeTecniche.filter(
              (item) =>
                item.status !== "Completato" &&
                item.status !== "Completata"
            ),
          ],
        };
      })
    );

    setInterventiCliente(
      risultati.flatMap((item) => item.interventi)
    );

    setScadenzeCliente(
      risultati.flatMap((item) => item.scadenze)
    );
  } catch (err) {
    console.error("Errore apertura scheda cliente:", err);
  }
};

useEffect(() => {
  if (!utenteCorrente || !localStorage.getItem("token")) {
    setClienti([]);
    return;
  }

  setClienti([]);
  caricaClienti();
}, [utenteCorrente?.idUtente, utenteCorrente?.company_id]);

const caricaNotifiche = async () => {
  try {
    const response = await authFetch(
      "/api/dashboard/notifications"
    );

    if (!response.ok) return;

    const data = await response.json();
    setNotifications(data);
  } catch (err) {
    console.error("Errore notifiche:", err);
  }
};

const unreadNotifications = notifications.filter(
  (notification) => !notification.is_read
);

const markNotificationAsRead = async (notificationId) => {
  try {
    await authFetch(
      `/api/notifications/${notificationId}/read`,
      {
        method: "PATCH",
      }
    );

    await caricaNotifiche();

  } catch (err) {
    console.error("Errore lettura notifica:", err);
  }
};

const archiveNotification = async (notificationId) => {
  try {
    await authFetch(
      `/api/notifications/${notificationId}/archive`,
      {
        method: "PATCH",
      }
    );

    await caricaNotifiche();

  } catch (err) {
    console.error("Errore archiviazione notifica:", err);
  }
};

useEffect(() => {
  caricaNotifiche();
}, []);

const handleGlobalSearch = async (value) => {
  setSearchQuery(value);

  if (value.trim().length < 2) {
    setSearchResults([]);
    return;
  }

  try {
    const response = await authFetch(
      `/api/search/?q=${encodeURIComponent(value)}`
    );

    if (!response.ok) return;

    const data = await response.json();

    setSearchResults(data.results || []);
    setShowSearchResults(true);

  } catch (err) {
    console.error("Errore ricerca globale:", err);
  }
};

const salvaNuovoCliente = async () => {
  try {
    const response = await authFetch(
      "/api/customers/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(nuovoCliente),
      }
    );

    if (!response.ok) {
      throw new Error("Errore salvataggio cliente");
    }

    await caricaClienti();

    setNuovoCliente({
  first_name: "",
  last_name: "",
  company_name: "",
  customer_type: "",
  customer_category: "",
  fiscal_code: "",
  vat_number: "",
  pec: "",
  sdi_code: "",
  phone: "",
  email: "",
  address: "",
  city: "",
  province: "",
  postal_code: "",
  notes: "",
});

    setMostraNuovoCliente(false);

  } catch (err) {
    console.error(err);
    alert("Errore durante il salvataggio");
  }
};

const apriModificaCliente = (cliente) => {
  setClienteInModifica(cliente);
  setMostraModificaCliente(true);
};
const salvaModificaCliente = async () => {
  try {
    const response = await authFetch(
      `/api/customers/${clienteInModifica.id}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(clienteInModifica),
      }
    );

    if (!response.ok) {
      throw new Error("Errore aggiornamento cliente");
    }

    await caricaClienti();

    setMostraModificaCliente(false);
    setClienteInModifica(null);
  } catch (err) {
    console.error(err);
    alert("Errore durante la modifica cliente");
  }
};

const eliminaCliente = async (clienteId) => {
  const conferma = window.confirm(
    "Vuoi davvero eliminare questo cliente?"
  );

  if (!conferma) return;

  try {
    const response = await authFetch(
      `/api/customers/${clienteId}`,
      {
        method: "DELETE",
      }
    );

    if (!response.ok) {
      throw new Error("Errore eliminazione cliente");
    }

    await caricaClienti();

  } catch (err) {
    console.error(err);
    alert("Errore durante eliminazione cliente");
  }
};

  const nativeDateRilascioRef = useRef(null);
  const nativeDateScadenzaRef = useRef(null);

  const [documenti, setDocumenti] = useState([]);

  const tuttiDocumenti = documenti;
  const mappaCategorie = {
    "Documenti personali": 1,
    "Carte bancarie": 2,
    "Casa e immobili": 3,
    "Protezione personale e familiare": 4,
    "Fisco e Tributi": 5,
    "Identità digitale": 6,
    "Previdenza Investimenti Debiti": 7,
    "Salute e prevenzione": 8,
    "Mobilità": 9,
    "Animali domestici": 10,
    "Varie": 11,
  };
const mappaCategorieInverse = {
  1: "Documenti personali",
  2: "Carte bancarie",
  3: "Casa e immobili",
  4: "Protezione personale e familiare",
  5: "Fisco e Tributi",
  6: "Identità digitale",
  7: "Previdenza Investimenti Debiti",
  8: "Salute e prevenzione",
  9: "Mobilità",
  10: "Animali domestici",
  11: "Varie",
};
  const [mostraFormDocumenti, setMostraFormDocumenti] = useState(false);
  const [isModificaDocumento, setIsModificaDocumento] = useState(false);
  const [documentoInModificaId, setDocumentoInModificaId] = useState(null);

  const [nuovoDocumento, setNuovoDocumento] = useState({
    intestatario: "",
    elemento: "",
    elementoAltro: "",
    dataRilascio: "",
    validita: "",
    dataScadenza: "",
    alert: "30 giorni",
  });

  const [filtroRicerca, setFiltroRicerca] = useState("");
  const [filtroIntestatario, setFiltroIntestatario] = useState("");
  const [filtroAlert, setFiltroAlert] = useState("");
  const [filtroStato, setFiltroStato] = useState("");

  const [vistaDashboardAttiva, setVistaDashboardAttiva] = useState(false);
  const [filtroDashboard, setFiltroDashboard] = useState("");
  const [now, setNow] = useState(new Date());

  const datePickerRilascioRef = useRef(null);
  const datePickerScadenzaRef = useRef(null);

  useEffect(() => {
  async function caricaDashboard() {
    try {
      setLoading(true);
      setErrore("");

      const token = localStorage.getItem("token");

      if (!token) {
        setLoading(false);
        return;
      }

      const res = await authFetch(
        "/api/dashboard/summary"
      );

      if (!res.ok) {
        throw new Error("Risposta non valida dal backend");
      }

      const json = await res.json();

      setData(json);

    } catch (e) {
      setErrore("Errore nel collegamento al backend");
      setData(null);

    } finally {
      setLoading(false);
    }
  }

  caricaDashboard();
}, [utenteCorrente]);

  useEffect(() => {
  const token = localStorage.getItem("token");

  if (!token) {
  return;
}

authFetch("/api/deadline-items/")
    .then((res) => {
      if (!res.ok) {
        throw new Error("Errore caricamento scadenze");
      }
      return res.json();
    })
    .then((data) => {
      const datiFormattati = data.map((item) => ({
        id: item.id,
        categoria: mappaCategorieInverse[item.category_id],
        intestatario: item.holder_name,
        elemento: item.title,
        elementoAltro: "",
        dataRilascio: item.issue_date
          ? item.issue_date.split("-").reverse().join("/")
          : "",
        validita: item.validita || "",
        dataScadenza: item.expiry_date
          .split("-")
          .reverse()
          .join("/"),
        alert: item.alert_days + " giorni",
      }));

      setDocumenti(datiFormattati);
    })
    .catch((err) => {
      console.error("Errore caricamento:", err);
    });
}, [utenteCorrente]);

  const [elementiPerCategoria, setElementiPerCategoria] = useState({
  "Documenti personali": [
    "Carta di identità",
    "CIE Carta d’Identità Elettronica",
    "Passaporto",
    "Patente di guida",
    "Patente nautica",
    "Licenza radio VHF nautica",
    "Tessera sanitaria",
    "Porto d’armi",
    "Tessera venatoria",
    "Licenza di caccia",
    "Tessera poligono di tiro",
    "Certificato medico uso armi",
    "Denuncia detenzione armi",
    "Licenza di pesca",
    "Certificato medico sportivo",
    "Attestato pilota drone (A1/A2/A3)",
    "Altro",
  ],
  "Carte bancarie": [
    "Carta di credito",
    "Bancomat/Carta di debito",
    "Carta prepagata",
    "Conti bancari",
    "Altro",
  ],
  "Casa e immobili": [
    "Assicurazione casa",
    "Manutenzione caldaia",
    "Controllo fumi caldaia",
    "Controllo estintori se presenti",
    "Altro",
  ],
  "Protezione personale e familiare": [
    "Assicurazione vita",
    "Polizza infortuni",
    "RC capofamiglia",
    "Tutela legale",
    "Assicurazione sanitaria",
    "Polizza viaggio",
    "Altro",
  ],
  "Fisco e Tributi": [
    "Dichiarazione dei redditi Modello 730",
    "Dichiarazione dei redditi Modello Persone Fisiche",
    "IMU (Imposta Municipale Propria)",
    "TARI (Tassa sui Rifiuti)",
    "Altro",
  ],
  "Identità digitale": [
    "PEC Posta Elettronica Certificata",
    "Firma digitale",
    "SPID Sistema Pubblico di Identità Digitale",
    "CNS Carta Nazionale dei Servizi",
    "Altro",
  ],
  "Previdenza Investimenti Debiti": [
    "Fondo pensione",
    "Polizze previdenziali",
    "Titoli di Stato (BTP, BOT, CCTeu, ecc.)",
    "Obbligazioni",
    "Portafoglio investimenti",
    "Certificati di deposito",
    "Vincoli di deposito",
    "Polizze di investimento",
    "Piani di accumulo PAC",
    "Rinegoziazione mutuo",
    "Leasing",
    "Finanziamenti/prestiti personali",
    "Altro",
  ],
  "Salute e prevenzione": [
    "Visita cardiologica di controllo",
    "Elettrocardiogramma (ECG)",
    "Visita oculistica completa",
    "Controllo ortopedico/posturale",
    "Controllo udito (audiometria)",
    "Pap test / HPV test",
    "Screening colon-retto",
    "Mammografia",
    "PSA prostata",
    "Densitometria ossea (MOC)",
    "Ecografie preventive (addome, tiroide ecc.)",
    "Altro",
  ],
  "Mobilità": [
    "Abbonamenti trasporto pubblico autobus/metro/treno urbano",
    "Abbonamenti integrati regionali",
    "Abbonamenti/Permessi ZTL residenti",
    "Abbonamenti/Permessi pass parcheggio residenti",
    "Altro",
  ],
  "Animali domestici": [
    "Vaccinazioni",
    "Antiparassitari",
    "Assicurazione animale",
    "Controlli veterinari",
    "Altro",
  ],
  "Varie": [
    "Altro",
  ],
});

  const alertOptions = [
    "7 giorni",
    "15 giorni",
    "30 giorni",
    "60 giorni",
    "90 giorni",
    "120 giorni",
    "180 giorni",
  ];

  const boxStyle = {
  width: "280px",
  border: "1px solid #cfd8e3",
  borderRadius: "12px",
  overflow: "hidden",
  cursor: "pointer",
  backgroundColor: "#ffffff",
  boxShadow: "0 3px 10px rgba(0,0,0,0.08)",
  display: "flex",
  flexDirection: "column",
  textAlign: "center",

  transition:
    "transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease",
};

const menuButtonStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: sidebarOpen ? "flex-start" : "center",
  width: "100%",
  padding: sidebarOpen ? "10px 14px" : "10px",
  marginBottom: "12px",
  backgroundColor: "#ffffff",
  border: "2px solid #b7c7dd",
  borderRadius: "14px",
  cursor: "pointer",
  fontSize: "16px",
  fontWeight: 400,
  letterSpacing: "0px",
  lineHeight: "1.1",
  color: "#0f172a",
  gap: sidebarOpen ? "12px" : "0px",
  textAlign: "left",
  height: "56px",
  boxSizing: "border-box",
  transition:
    "background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease",
};

function getButtonStyle(isActive, buttonKey = "") {
  const isHovered = hoveredButton === buttonKey;

  return {
    ...menuButtonStyle,
    backgroundColor: isActive
      ? "#e7f0fb"
      : isHovered
      ? "#f8fbff"
      : "#ffffff",
    border: isActive
      ? "2px solid #b7c7dd"
      : isHovered
      ? "2px solid #a9bfdc"
      : "2px solid #b7c7dd",
    boxShadow: isActive
      ? "0 2px 6px rgba(0,0,0,0.06)"
      : isHovered
      ? "0 4px 10px rgba(0,0,0,0.06)"
      : "none",
    transform: isHovered ? "translateY(-1px)" : "translateY(0)",
    transition:
      "background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease",
  };
}

const sectionTitleStyle = {
  fontSize: "13px",
  fontWeight: 700,
  color: "#475569",
  marginTop: "28px",
  marginBottom: "14px",
  textTransform: "uppercase",
  letterSpacing: "0.8px",
  borderBottom: "1px solid #d6deea",
  paddingBottom: "8px",
  paddingLeft: "2px",
  background: "linear-gradient(to right, rgba(214,222,234,0.18), rgba(214,222,234,0))",
};


// 👇 POI CONTINUA

const labelStyle = {
  display: "block",
  marginBottom: "7px",
  fontWeight: 600,
  fontSize: "14px",
  color: "#173a63",
  letterSpacing: "0.1px",
};

  function parseDataItaliana(value) {
    if (!value || value.length !== 10) return null;

    const [giorno, mese, anno] = value.split("/");
    const data = new Date(Number(anno), Number(mese) - 1, Number(giorno));

    if (Number.isNaN(data.getTime())) return null;
    return data;
  }

  function handleChangeDocumento(e) {
  const { name, value } = e.target;

  setNuovoDocumento((prev) => {
    if (name === "elemento") {
      return {
        ...prev,
        elemento: value,
        elementoAltro: value === "Altro" ? prev.elementoAltro : "",
      };
    }

    return {
      ...prev,
      [name]: value,
    };
  });
}

  function aggiornaDataDocumento(nomeCampo, dateObj) {
    const formatted = dateObj ? dateObj.toLocaleDateString("it-IT") : "";

    setNuovoDocumento((prev) => ({
      ...prev,
      [nomeCampo]: formatted,
    }));

    if (nomeCampo === "dataRilascio") {
    }

    if (nomeCampo === "dataScadenza") {
    }
  }

  function resetFormDocumento() {
    setNuovoDocumento({
      intestatario: "",
      elemento: "",
      elementoAltro: "",
      dataRilascio: "",
      validita: "",
      dataScadenza: "",
      alert: "30 giorni",
    });
    setMostraFormDocumenti(false);
    setIsModificaDocumento(false);
    setDocumentoInModificaId(null);
  }

  function validaDocumento() {
    if (
      !nuovoDocumento.intestatario ||
      !nuovoDocumento.elemento ||
      !nuovoDocumento.dataRilascio ||
      !nuovoDocumento.validita ||
      !nuovoDocumento.dataScadenza ||
      !nuovoDocumento.alert
    ) {
      alert("Compila tutti i campi obbligatori.");
      return false;
    }

    if (nuovoDocumento.elemento === "Altro" && !nuovoDocumento.elementoAltro.trim()) {
      alert("Inserisci il nome del documento nel campo Altro.");
      return false;
    }

    if (
      nuovoDocumento.dataRilascio.length !== 10 ||
      nuovoDocumento.dataScadenza.length !== 10
    ) {
      alert("Le date devono essere complete nel formato gg/mm/aaaa.");
      return false;
    }

    return true;
  }

  function handleNuovoInserimento() {
    resetFormDocumento();
    setMostraFormDocumenti(true);
  }

  function handlePrimaryHover(e) {
  e.currentTarget.style.backgroundColor = "#1d4ed8";
  e.currentTarget.style.transform = "translateY(-1px)";
  e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.08)";
}

function handlePrimaryLeave(e) {
  e.currentTarget.style.backgroundColor = "#2563eb";
  e.currentTarget.style.transform = "translateY(0)";
  e.currentTarget.style.boxShadow = "none";
}

function handlePrimaryDown(e) {
  e.currentTarget.style.transform = "translateY(0)";
  e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)";
}

function handleInputFocus(e) {
  e.currentTarget.style.borderColor = "#9db7d8";
  e.currentTarget.style.boxShadow = "0 0 0 2px rgba(157, 183, 216, 0.2)";
}

function handleInputBlur(e) {
  e.currentTarget.style.borderColor = "#cfd8e3";
  e.currentTarget.style.boxShadow = "none";
}

function handleSecondaryHover(e) {
  e.currentTarget.style.backgroundColor = "#eef5ff";
  e.currentTarget.style.borderColor = "#9db7d8";
  e.currentTarget.style.transform = "translateY(-1px)";
  e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.06)";
}

function handleSecondaryLeave(e) {
  e.currentTarget.style.backgroundColor = "#f8f9fa";
  e.currentTarget.style.borderColor = "#cfd8e3";
  e.currentTarget.style.transform = "translateY(0)";
  e.currentTarget.style.boxShadow = "none";
}

function handleSecondaryDown(e) {
  e.currentTarget.style.transform = "translateY(0)";
  e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.08)";
}

function handleDangerHover(e) {
  e.currentTarget.style.backgroundColor = "#b91c1c";
  e.currentTarget.style.transform = "translateY(-1px)";
  e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.08)";
}

function handleDangerLeave(e) {
  e.currentTarget.style.backgroundColor = "#dc3545";
  e.currentTarget.style.transform = "translateY(0)";
  e.currentTarget.style.boxShadow = "none";
}

function handleDangerDown(e) {
  e.currentTarget.style.transform = "translateY(0)";
  e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)";
}

 function handleSalvaDocumento(caricaDocumentoDopo = false) {
  if (!validaDocumento()) return;

  const conferma = window.confirm("Confermi il salvataggio della scadenza?");
  if (!conferma) return;

  const documentoFinale = {
    id:
      isModificaDocumento && documentoInModificaId !== null
        ? documentoInModificaId
        : tuttiDocumenti.length > 0
        ? Math.max(...tuttiDocumenti.map((d) => d.id)) + 1
        : 1,
    categoria: categoriaAttiva,
    intestatario: nuovoDocumento.intestatario,
    elemento:
      nuovoDocumento.elemento === "Altro"
        ? nuovoDocumento.elementoAltro.trim()
        : nuovoDocumento.elemento,
    elementoAltro:
      nuovoDocumento.elemento === "Altro"
        ? nuovoDocumento.elementoAltro.trim()
        : "",
    dataRilascio: nuovoDocumento.dataRilascio,
    validita: nuovoDocumento.validita,
    dataScadenza: nuovoDocumento.dataScadenza,
    alert: nuovoDocumento.alert,
  };

  if (isModificaDocumento && documentoInModificaId !== null) {
    const token = localStorage.getItem("token");

    authFetch(
  `/api/deadline-items/${documentoInModificaId}`,
  {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
      body: JSON.stringify({
        category_id: mappaCategorie[categoriaAttiva],
        title: documentoFinale.elemento,
        holder_name: documentoFinale.intestatario,
        validita: documentoFinale.validita,
        issue_date: documentoFinale.dataRilascio
          ? documentoFinale.dataRilascio.split("/").reverse().join("-")
          : null,
        expiry_date: documentoFinale.dataScadenza
          .split("/")
          .reverse()
          .join("-"),
        alert_days: parseInt(documentoFinale.alert),
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        console.log("Aggiornato backend:", data);

       const documentoAggiornato = {
  id: data.id,
  categoria: mappaCategorieInverse[data.category_id],
  intestatario: data.holder_name,
  elemento: data.title,
  elementoAltro: "",
  dataRilascio: data.issue_date
    ? data.issue_date.split("-").reverse().join("/")
    : "",
  validita: data.validita || "",
  dataScadenza: data.expiry_date.split("-").reverse().join("/"),
  alert: data.alert_days + " giorni",
};

setDocumenti((prev) =>
  prev.map((doc) =>
    doc.id === documentoInModificaId ? documentoAggiornato : doc
  )
); 

setData((prev) => {
  if (!prev) return prev;

  // Ricalcolo completo (più sicuro della logica incrementale)
  const nuoviDocumenti = documenti.map((doc) =>
    doc.id === documentoInModificaId ? documentoAggiornato : doc
  );

  let scadute = 0;
  let in_scadenza = 0;
  let ok = 0;

  const oggi = new Date();

  nuoviDocumenti.forEach((doc) => {
    const parts = doc.dataScadenza.split("/");
    const scadenza = new Date(parts[2], parts[1] - 1, parts[0]);

    const diffDays = Math.ceil((scadenza - oggi) / (1000 * 60 * 60 * 24));

    const alertDays = parseInt(doc.alert);

    if (diffDays < 0) scadute++;
    else if (diffDays <= alertDays) in_scadenza++;
    else ok++;
  });

  return {
    total: nuoviDocumenti.length,
    scadute,
    in_scadenza,
    ok,
  };
});

const datiDocumentoCollegato = {
  scadenzaId: documentoFinale.id,
  intestatario: documentoFinale.intestatario,
  destinazione: documentoFinale.categoria,
  tipoDocumento: documentoFinale.elemento,
};

resetFormDocumento();

if (caricaDocumentoDopo) {
  setPrefillDocumento(datiDocumentoCollegato);
  setSezione("gestione_documenti");
  setTabAttivoDocumenti("inserisci");
}
      })
      .catch((err) => {
        console.error("Errore update:", err);
        alert("Errore aggiornamento backend");
      });
  } else {
    const token = localStorage.getItem("token");

authFetch("/api/deadline-items/", {
  method: "POST",
  headers: {
    "Content-Type": "application/json",
  },
  body: JSON.stringify({
    category_id: mappaCategorie[categoriaAttiva],
    title: documentoFinale.elemento,
    holder_name: documentoFinale.intestatario,
    validita: documentoFinale.validita,
    issue_date: documentoFinale.dataRilascio
      ? documentoFinale.dataRilascio.split("/").reverse().join("-")
      : null,
    expiry_date: documentoFinale.dataScadenza
      .split("/")
      .reverse()
      .join("-"),
    alert_days: parseInt(documentoFinale.alert),
  }),
})
      .then((res) => res.json())
      .then((data) => {
        console.log("Salvato backend:", data);
const documentoSalvato = {
  id: data.id,
  categoria: mappaCategorieInverse[data.category_id],
  intestatario: data.holder_name,
  elemento: data.title,
  elementoAltro: "",
  dataRilascio: data.issue_date
    ? data.issue_date.split("-").reverse().join("/")
    : "",
  validita: data.validita || "",
  dataScadenza: data.expiry_date.split("-").reverse().join("/"),
  alert: data.alert_days + " giorni",
};

setDocumenti((prev) => [...prev, documentoSalvato]);

setData((prev) => {
  if (!prev) return prev;

  const oggi = new Date();
  const scadenza = new Date(data.expiry_date);
  const diffDays = Math.ceil((scadenza - oggi) / (1000 * 60 * 60 * 24));

  return {
    ...prev,
    total: prev.total + 1,
    scadute: diffDays < 0 ? prev.scadute + 1 : prev.scadute,
    in_scadenza:
      diffDays >= 0 && diffDays <= data.alert_days
        ? prev.in_scadenza + 1
        : prev.in_scadenza,
    ok: diffDays > data.alert_days ? prev.ok + 1 : prev.ok,
  };
});

const datiDocumentoCollegato = {
  scadenzaId: documentoFinale.id,
  intestatario: documentoFinale.intestatario,
  destinazione: documentoFinale.categoria,
  tipoDocumento: documentoFinale.elemento,
};

resetFormDocumento();

if (caricaDocumentoDopo) {
  setPrefillDocumento(datiDocumentoCollegato);
  setSezione("gestione_documenti");
  setTabAttivoDocumenti("inserisci");
}
    
      })
      .catch((err) => {
        console.error("Errore salvataggio:", err);
        alert("Errore nel salvataggio backend");
      });
  }
}

  function handleClickRigaDocumento(doc) {
    const isElementoPredefinito = (elementiPerCategoria[categoriaAttiva] || []).includes(doc.elemento);

    setNuovoDocumento({
      intestatario: doc.intestatario,
      elemento: isElementoPredefinito ? doc.elemento : "Altro",
      elementoAltro: isElementoPredefinito ? "" : doc.elemento,
      dataRilascio: doc.dataRilascio,
      validita: doc.validita,
      dataScadenza: doc.dataScadenza,
      alert: doc.alert,
    });

    setDocumentoInModificaId(doc.id);
    setIsModificaDocumento(true);
    setMostraFormDocumenti(true);
  }

  function handleEliminaDocumento() {
  if (documentoInModificaId === null) return;

  const conferma = window.confirm(
    "Confermi l'eliminazione del documento selezionato?"
  );
  if (!conferma) return;

  const token = localStorage.getItem("token");

authFetch(
  `/api/deadline-items/${documentoInModificaId}`,
  {
    method: "DELETE",
  }
)
  .then((res) => res.json())
  .then((data) => {
    console.log("Eliminato backend:", data);

    const nuoviDocumenti = documenti.filter(
      (doc) => doc.id !== documentoInModificaId
    );

    setDocumenti(nuoviDocumenti);

    let scadute = 0;
    let in_scadenza = 0;
    let ok = 0;

    const oggi = new Date();

    nuoviDocumenti.forEach((doc) => {
      const parts = doc.dataScadenza.split("/");
      const scadenza = new Date(parts[2], parts[1] - 1, parts[0]);
      const diffDays = Math.ceil((scadenza - oggi) / (1000 * 60 * 60 * 24));
      const alertDays = parseInt(doc.alert);

      if (diffDays < 0) scadute++;
      else if (diffDays <= alertDays) in_scadenza++;
      else ok++;
    });

    setData({
      total: nuoviDocumenti.length,
      scadute,
      in_scadenza,
      ok,
    });

    resetFormDocumento();
  })
  .catch((err) => {
    console.error("Errore delete:", err);
    alert("Errore eliminazione backend");
  });
}

  function renderDateInput(nomeCampo, valore, inputRef) {
  function italianaToIso(dataIt) {
    if (!dataIt || dataIt.length !== 10) return "";
    const [gg, mm, aaaa] = dataIt.split("/");
    return `${aaaa}-${mm}-${gg}`;
  }

  function isoToItaliana(dataIso) {
    if (!dataIso) return "";
    const [aaaa, mm, gg] = dataIso.split("-");
    return `${gg}/${mm}/${aaaa}`;
  }

  return (
    <input
      ref={inputRef}
      type="date"
      lang="it-IT"
      style={inputStyle}
      value={italianaToIso(valore)}
      onChange={(e) => {
        const nuovaData = isoToItaliana(e.target.value);

        setNuovoDocumento((prev) => ({
          ...prev,
          [nomeCampo]: nuovaData,
        }));
      }}
      onFocus={handleInputFocus}   // 👈 AGGIUNGI
  onBlur={handleInputBlur}     // 👈 AGGIUNGI
    />
  );
}

function getDocumentoCollegato(scadenzaId) {
  const listaRaw = documentiFile[utenteCorrente?.idUtente] || [];

  const lista = Array.isArray(listaRaw) ? listaRaw : [];

  return lista.find(
    (file) => String(file.scadenzaId) === String(scadenzaId)
  );
}

    function renderDocumentiCategoria() {
    return (
      <>
  <h1 style={pageTitleStyle}>
  {vistaDashboardAttiva
    ? filtroDashboard === "totale"
      ? "Elenco di tutti i documenti"
      : filtroDashboard === "scadute"
      ? "Documenti scaduti"
      : filtroDashboard === "in_scadenza"
      ? "Documenti in scadenza"
      : "Documenti non in scadenza"
    : categoriaAttiva}
</h1>

<p style={pageSubtitleStyle}>
  {vistaDashboardAttiva
    ? "Visualizzazione filtrata dei documenti"
    : `Gestisci i documenti relativi a ${categoriaAttiva.toLowerCase()}`}
</p>
     {vistaDashboardAttiva && (
  <button
    onClick={() => {
      setVistaDashboardAttiva(false);
      setFiltroDashboard("");
      setFiltroStato("");
      setSezione("home");
    }}
    style={{
      marginBottom: "20px",
      padding: "10px 16px",
      backgroundColor: "#f8fbff",
      border: "1px solid #cfd8e3",
      borderRadius: "10px",
      cursor: "pointer",
      fontSize: "14px",
      fontWeight: 500,
      color: "#173a63",
      display: "inline-flex",
      alignItems: "center",
      gap: "6px",
      transition: "all 0.15s ease",
    }}
    onMouseEnter={(e) => {
  e.currentTarget.style.transform = "translateY(-7px) scale(1.035)";
  e.currentTarget.style.boxShadow =
    "0 18px 36px rgba(37, 99, 235, 0.24)";
  e.currentTarget.style.borderColor = "#3b82f6";
  e.currentTarget.style.background =
    "linear-gradient(180deg, #ffffff 0%, #eef5ff 100%)";
}}

onMouseLeave={(e) => {
  e.currentTarget.style.transform = "translateY(0) scale(1)";
  e.currentTarget.style.boxShadow =
    "0 4px 14px rgba(0,0,0,0.05)";
  e.currentTarget.style.borderColor = "#d6deea";
  e.currentTarget.style.background =
    "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)";
}}

onMouseDown={(e) => {
  e.currentTarget.style.transform = "translateY(-2px) scale(0.985)";
}}
  >
    ← Dashboard
  </button>
)}

{!vistaDashboardAttiva && (
  <div style={{ marginBottom: "20px" }}>
  <button
  style={primaryButtonStyle}
  onClick={handleNuovoInserimento}
  onMouseEnter={handlePrimaryHover}
  onMouseLeave={handlePrimaryLeave}
  onMouseDown={handlePrimaryDown}
>
  Nuovo inserimento
</button>
  </div>
)}

<div
  style={{
    border: "1px solid #d6deea",
    borderRadius: "14px",
    padding: "20px",
    marginBottom: "22px",
    backgroundColor: "#f8fbff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    maxWidth: "700px",
    width: "100%",
    boxSizing: "border-box",
    margin: "0 0 28px 0",
  }}
>
  <p
    style={{
      marginBottom: "14px",
      fontWeight: 600,
      fontSize: "15px",
      color: "#173a63",
      letterSpacing: "0.3px",
    }}
  >
    Filtri elenco
  </p>

  <div
    style={{
      display: "flex",
      gap: "10px",
      flexWrap: "wrap",
    }}
  >
    <input
      style={{ ...inputStyle, maxWidth: "200px" }}
      placeholder="Ricerca..."
      value={filtroRicerca}
      onChange={(e) => setFiltroRicerca(e.target.value)}
    />

    <input
      style={{ ...inputStyle, maxWidth: "180px" }}
      placeholder="Intestatario"
      value={filtroIntestatario}
      onChange={(e) => setFiltroIntestatario(e.target.value)}
    />

    <select
      style={{ ...inputStyle, maxWidth: "180px" }}
      value={filtroAlert}
      onChange={(e) => setFiltroAlert(e.target.value)}
      onFocus={handleInputFocus}
  onBlur={handleInputBlur}
    >
      <option value="">Tutti gli alert</option>
      {alertOptions.map((item) => (
        <option key={item} value={item}>
          {item}
        </option>
      ))}
    </select>

    <select
      style={{ ...inputStyle, maxWidth: "180px" }}
      value={filtroStato}
      onChange={(e) => setFiltroStato(e.target.value)}
      onFocus={handleInputFocus}
  onBlur={handleInputBlur}
    >
      <option value="">Tutti gli stati</option>
      <option value="ok">OK</option>
      <option value="in_scadenza">In scadenza</option>
      <option value="scaduto">Scaduto</option>
    </select>

   <button
  style={{
    ...secondaryButtonStyle,
    height: "42px",
    marginRight: 0,
  }}
  onClick={() => {
    setFiltroRicerca("");
    setFiltroIntestatario("");
    setFiltroAlert("");

    if (vistaDashboardAttiva) {
      if (filtroDashboard === "totale") {
        setFiltroStato("");
      } else if (filtroDashboard === "scadute") {
        setFiltroStato("scaduto");
      } else if (filtroDashboard === "in_scadenza") {
        setFiltroStato("in_scadenza");
      } else if (filtroDashboard === "ok") {
        setFiltroStato("ok");
      }
    } else {
      setFiltroStato("");
    }
  }}
  onMouseEnter={handleSecondaryHover}
  onMouseLeave={handleSecondaryLeave}
  onMouseDown={handleSecondaryDown}
>
  Pulisci filtri
</button>
  </div>
</div>

{mostraFormDocumenti && !vistaDashboardAttiva && (
 <div
  style={{
    border: "1px solid #d6deea",
    borderRadius: "14px",
    padding: "22px",
    marginBottom: "30px",
    backgroundColor: "#f8fbff", // 👈 stesso dei filtri
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    maxWidth: "700px",
    color: "#173a63", // 👈 stesso colore sidebar
  }}
>
<h2 style={{ ...pageTitleStyle, fontSize: "26px", marginBottom: "8px" }}>
  {isModificaDocumento ? "Modifica documento" : "Nuovo inserimento"}
</h2>

<p style={{ ...pageSubtitleStyle, fontSize: "13px", marginBottom: "22px" }}>
  * i campi contrassegnati con asterisco sono obbligatori
</p>

<div
  style={{
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "18px 22px",
  }}
>
  <div>
    <label style={labelStyle}>Intestatario *</label>
    <input
      style={inputStyle}
      type="text"
      name="intestatario"
      value={nuovoDocumento.intestatario}
      onChange={handleChangeDocumento}
      onFocus={handleInputFocus}
      onBlur={handleInputBlur}
    />
  </div>

  <div>
    <label style={labelStyle}>Elemento *</label>
    <select
      style={inputStyle}
      name="elemento"
      value={nuovoDocumento.elemento}
      onChange={handleChangeDocumento}
      onFocus={handleInputFocus}
      onBlur={handleInputBlur}
    >
      <option value="">Seleziona un elemento</option>
      {(elementiPerCategoria[categoriaAttiva] || []).map((item) => (
        <option key={item} value={item}>
          {item}
        </option>
      ))}
    </select>
  </div>

  <div style={{ gridColumn: "1 / -1", color: "#173a63", fontSize: "14px" }}>
    Elemento selezionato: {nuovoDocumento.elemento}
  </div>

  {(nuovoDocumento.elemento === "Altro" || nuovoDocumento.elementoAltro) && (
    <div style={{ gridColumn: "1 / -1" }}>
      <label style={labelStyle}>Specifica documento *</label>
      <input
        style={inputStyle}
        type="text"
        name="elementoAltro"
        placeholder="Scrivi il nome del documento"
        value={nuovoDocumento.elementoAltro}
        onChange={handleChangeDocumento}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        autoComplete="off"
      />
    </div>
  )}

  <div>
    <label style={labelStyle}>Data di rilascio / ultimo rinnovo *</label>
    {renderDateInput(
      "dataRilascio",
      nuovoDocumento.dataRilascio,
      nativeDateRilascioRef
    )}
  </div>

  <div>
    <label style={labelStyle}>Data di scadenza / prossimo rinnovo *</label>
    {renderDateInput(
      "dataScadenza",
      nuovoDocumento.dataScadenza,
      nativeDateScadenzaRef
    )}
  </div>

  <div>
    <label style={labelStyle}>Validità *</label>

    <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
      <input
        style={{
          ...inputStyle,
          marginBottom: 0,
          flex: "0 0 140px",
        }}
        type="number"
        min="1"
        placeholder="es. 10"
        value={nuovoDocumento.validita?.split(" ")[0] || ""}
        onChange={(e) => {
          const numero = e.target.value;
          const unita = nuovoDocumento.validita?.split(" ")[1] || "anni";

          setNuovoDocumento((prev) => ({
            ...prev,
            validita: numero ? `${numero} ${unita}` : "",
          }));
        }}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
      />

      <select
        style={{
          ...inputStyle,
          marginBottom: 0,
          flex: "0 0 140px",
        }}
        value={nuovoDocumento.validita?.split(" ")[1] || "anni"}
        onChange={(e) => {
          const unita = e.target.value;
          const numero = nuovoDocumento.validita?.split(" ")[0] || "";

          setNuovoDocumento((prev) => ({
            ...prev,
            validita: numero ? `${numero} ${unita}` : "",
          }));
        }}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
      >
        <option value="giorni">giorni</option>
        <option value="mesi">mesi</option>
        <option value="anni">anni</option>
      </select>
    </div>
  </div>

  <div>
    <label style={labelStyle}>Alert *</label>
    <select
      style={inputStyle}
      name="alert"
      value={nuovoDocumento.alert}
      onChange={handleChangeDocumento}
      onFocus={handleInputFocus}
      onBlur={handleInputBlur}
    >
      {alertOptions.map((item) => (
        <option key={item} value={item}>
          {item}
        </option>
      ))}
    </select>
  </div>
</div>

<div
  style={{
    display: "flex",
    gap: "12px",
    alignItems: "center",
    marginTop: "24px",
    flexWrap: "wrap",
  }}
>

  {/* 👉 NUOVO BOTTONE */}
  <button
  style={{
    ...primaryButtonStyle,
    backgroundColor: "#16a34a",
    borderColor: "#16a34a",
    boxShadow: "0 2px 6px rgba(0,0,0,0.10)",
    transition: "all 0.18s ease",
  }}
  onClick={() => handleSalvaDocumento(true)}
  onMouseEnter={(e) => {
    e.currentTarget.style.backgroundColor = "#15803d";
    e.currentTarget.style.transform = "translateY(-2px) scale(1.015)";
    e.currentTarget.style.boxShadow = "0 8px 18px rgba(22, 163, 74, 0.28)";
  }}
  onMouseLeave={(e) => {
    e.currentTarget.style.backgroundColor = "#16a34a";
    e.currentTarget.style.transform = "translateY(0) scale(1)";
    e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.10)";
  }}
  onMouseDown={(e) => {
    e.currentTarget.style.transform = "translateY(0) scale(0.98)";
  }}
  onMouseUp={(e) => {
    e.currentTarget.style.transform = "translateY(-2px) scale(1.015)";
  }}
>
  Salva scadenza e carica documento
</button>

  <button
    style={primaryButtonStyle}
    onClick={() => handleSalvaDocumento(false)}
    onMouseEnter={handlePrimaryHover}
    onMouseLeave={handlePrimaryLeave}
    onMouseDown={handlePrimaryDown}
  >
    {isModificaDocumento ? "Salva modifiche" : "Salva solo scadenza"}
  </button>

  <button
  style={{ ...secondaryButtonStyle, marginRight: 0 }}
  onClick={resetFormDocumento}
  onMouseEnter={handleSecondaryHover}
  onMouseLeave={handleSecondaryLeave}
  onMouseDown={handleSecondaryDown}
>
  Annulla
</button>

 {isModificaDocumento && (
  <button
    style={dangerButtonStyle}
    onClick={handleEliminaDocumento}
    onMouseEnter={handleDangerHover}
    onMouseLeave={handleDangerLeave}
    onMouseDown={handleDangerDown}
  >
    Elimina
  </button>
)}
</div>
          </div>
        )}

    <div
  className="table-wrapper-pro"
  style={{
    border: "1px solid #d6deea",
    borderRadius: "14px",
    maxHeight: "calc(100vh - 360px)",
    minHeight: "260px",
    overflow: "auto",
    backgroundColor: "#ffffff",
    boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
    maxWidth: "100%",
    boxSizing: "border-box",
  }}
>
  <table
  className="table-pro"
  style={{
    width: "100%",
    minWidth: "980px",
    borderCollapse: "collapse",
    fontSize: "14px",
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  }}
>
    <thead
      style={{
        backgroundColor: "#f3f6fa",
        color: "#173a63",
        borderBottom: "1px solid #d6deea",
      }}
    >
      <tr>
        <th style={{ padding: "14px 12px", textAlign: "left", fontWeight: 600 }}>
          Intestatario
        </th>
        <th style={{ padding: "14px 12px", textAlign: "left", fontWeight: 600 }}>
          Elemento
        </th>
        <th style={{ padding: "14px 12px", textAlign: "left", fontWeight: 600 }}>
          Categoria
        </th>
        <th style={{ padding: "14px 12px", textAlign: "left", fontWeight: 600 }}>
          Data rilascio
        </th>
        <th style={{ padding: "14px 12px", textAlign: "left", fontWeight: 600 }}>
          Validità
        </th>
        <th style={{ padding: "14px 12px", textAlign: "left", fontWeight: 600 }}>
          Data scadenza
        </th>
        <th style={{ padding: "14px 12px", textAlign: "left", fontWeight: 600 }}>
          Alert
        </th>
        <th style={{ padding: "14px 12px", textAlign: "left", fontWeight: 600 }}>
          Azioni
        </th>
      </tr>
    </thead>

    <tbody>  
  {tuttiDocumenti.filter((doc) =>
  vistaDashboardAttiva ? true : doc.categoria === categoriaAttiva
  )
  .filter((doc) => {
    const ricerca = filtroRicerca.toLowerCase().trim();
    const intestatarioFiltro = filtroIntestatario.toLowerCase().trim();

    const matchRicerca =
      !ricerca ||
      doc.intestatario.toLowerCase().includes(ricerca) ||
      doc.elemento.toLowerCase().includes(ricerca);

    const matchIntestatario =
      !intestatarioFiltro ||
      doc.intestatario.toLowerCase().includes(intestatarioFiltro);

    const matchAlert = !filtroAlert || doc.alert === filtroAlert;

    const oggi = new Date();
    const [giorno, mese, anno] = doc.dataScadenza.split("/");
    const dataScadenza = new Date(Number(anno), Number(mese) - 1, Number(giorno));

    const differenzaGiorni = Math.ceil(
      (dataScadenza - oggi) / (1000 * 60 * 60 * 24)
    );

    const giorniAlert = parseInt(doc.alert);

    let statoDocumento = "ok";
    if (differenzaGiorni < 0) {
      statoDocumento = "scaduto";
    } else if (differenzaGiorni <= giorniAlert) {
      statoDocumento = "in_scadenza";
    }

    const matchStato = !filtroStato || statoDocumento === filtroStato;

    return matchRicerca && matchIntestatario && matchAlert && matchStato;
  })
  .sort((a, b) => {
    const [giornoA, meseA, annoA] = a.dataScadenza.split("/");
    const [giornoB, meseB, annoB] = b.dataScadenza.split("/");

    const dataA = new Date(Number(annoA), Number(meseA) - 1, Number(giornoA));
    const dataB = new Date(Number(annoB), Number(meseB) - 1, Number(giornoB));

    return dataA - dataB;
  })
  .map((doc) => (
<tr
  key={doc.id}
  style={{
    borderTop: "1px solid #eef2f7",
    backgroundColor: (() => {
      const oggi = new Date();
      const [giorno, mese, anno] = doc.dataScadenza.split("/");
      const dataScadenza = new Date(Number(anno), Number(mese) - 1, Number(giorno));

      const differenzaGiorni = Math.ceil(
        (dataScadenza - oggi) / (1000 * 60 * 60 * 24)
      );

      const giorniAlert = parseInt(doc.alert);

      if (differenzaGiorni < 0) return "#fdecec";
      if (differenzaGiorni <= giorniAlert) return "#fff7ed";
      return "#f0fdf4";
    })(),
    transition: "all 0.15s ease",
  }}
  onMouseEnter={(e) => {
  e.currentTarget.style.transform = "translateY(-2px)";
  e.currentTarget.style.boxShadow = "0 6px 14px rgba(0,0,0,0.08)";
}}

onMouseLeave={(e) => {
  e.currentTarget.style.transform = "translateY(0)";
  e.currentTarget.style.boxShadow = "none";
}}

onMouseDown={(e) => {
  e.currentTarget.style.transform = "translateY(0) scale(0.98)";
}}

onMouseUp={(e) => {
  e.currentTarget.style.transform = "translateY(-2px)";
}}
>
                  <td style={{ padding: "12px" }}>{doc.intestatario}</td>
                  <td style={{ padding: "12px" }}>{doc.elemento}</td>
                  <td style={{ padding: "12px" }}>{doc.categoria}</td>
                  <td style={{ padding: "12px" }}>{doc.dataRilascio}</td>
                  <td style={{ padding: "12px" }}>{doc.validita}</td>
                  <td style={{ padding: "12px" }}>{doc.dataScadenza}</td>
                  <td style={{ padding: "12px" }}>
  {(() => {
    const oggi = new Date();
    const [giorno, mese, anno] = doc.dataScadenza.split("/");
    const dataScadenza = new Date(Number(anno), Number(mese) - 1, Number(giorno));

    const differenzaGiorni = Math.ceil(
      (dataScadenza - oggi) / (1000 * 60 * 60 * 24)
    );

    const giorniAlert = parseInt(doc.alert);

    let statoLabel = "OK";
    let statoColor = "#16a34a";
    let statoBg = "#dcfce7";

    if (differenzaGiorni < 0) {
      statoLabel = "Scaduto";
      statoColor = "#dc2626";
      statoBg = "#fee2e2";
    } else if (differenzaGiorni <= giorniAlert) {
      statoLabel = "In scadenza";
      statoColor = "#d97706";
      statoBg = "#ffedd5";
    }

    return (
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        <span>{doc.alert}</span>

        <span
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "4px 8px",
            borderRadius: "999px",
            backgroundColor: statoBg,
            color: statoColor,
            fontSize: "12px",
            fontWeight: 600,
            whiteSpace: "nowrap",
          }}
        >
          <span
            style={{
              width: "8px",
              height: "8px",
              borderRadius: "50%",
              backgroundColor: statoColor,
              display: "inline-block",
            }}
          />
          {statoLabel}
        </span>
      </div>
    );
  })()}
</td>

             <td style={{ padding: "12px" }}>

  {/* 👉 SOLO IN CATEGORIA */}
  {!vistaDashboardAttiva && (
    <button
      style={secondaryButtonStyle}
      onClick={() => handleClickRigaDocumento(doc)}
      onMouseEnter={handleSecondaryHover}
      onMouseLeave={handleSecondaryLeave}
      onMouseDown={handleSecondaryDown}
    >
      Modifica dati
    </button>
  )}

  {/* 👉 SOLO IN DASHBOARD */}
  {vistaDashboardAttiva && getDocumentoCollegato(doc.id) && (
    <button
      style={{ ...secondaryButtonStyle }}
      onClick={() => {
  const token = localStorage.getItem("token");
  const file = getDocumentoCollegato(doc.id);
  window.open(`${file.fileUrl}?token=${token}`, "_blank");
}}
      onMouseEnter={handleSecondaryHover}
      onMouseLeave={handleSecondaryLeave}
      onMouseDown={handleSecondaryDown}
    >
      Apri documento
    </button>
  )}

</td>     
                </tr>
              ))}
        </tbody>
</table>
</div>
</>
);              
}

function apriVistaDashboard(tipo) {            

  
  setVistaDashboardAttiva(true);
  setFiltroDashboard(tipo);

  if (tipo === "totale") {
    setFiltroStato("");
  } else if (tipo === "scadute") {
    setFiltroStato("scaduto");
  } else if (tipo === "in_scadenza") {
    setFiltroStato("in_scadenza");
  } else if (tipo === "ok") {
    setFiltroStato("ok");
  }

  setMostraFormDocumenti(false);
  setSezione("documenti_personali");
  
}

  function renderContenuto() {
     if (sezione === "impianti") {
  return (
   <ImpiantiPage
  impiantoDaAprireId={impiantoDaAprireId}
  clientePreselezionato={clienteSelezionato}
  onImpiantoAperto={() => setImpiantoDaAprireId(null)}
  apriSchedaCliente={apriSchedaCliente}
  setSezione={setSezione}
  origineAperturaImpianto={origineAperturaImpianto}
  setOrigineAperturaImpianto={setOrigineAperturaImpianto}
/>
  );
}
if (sezione === "home") {
  return (
    <DashboardPage
  onOpenPlant={(plantId) => {
    setOrigineAperturaImpianto("dashboard");
    setImpiantoDaAprireId(plantId);
    setSezione("impianti");
  }}
  onOpenNotifications={() => {
    setShowNotifications(true);
  }}
/>
  );
}

if (sezione === "statistiche") {
  return <StatisticsPage />;
}

if (sezione === "calendario") {
  return (
    <CalendarPage
      onOpenPlant={(plantId) => {
        setImpiantoDaAprireId(plantId);
        setSezione("impianti");
      }}
    />
  );
}

   if (sezione === "clienti") {

  const timelineCliente = [
  ...impiantiCliente.map((impianto) => ({
  id: `impianto-${impianto.id}`,
  plant_id: impianto.id,
  tipo: "Impianto",
  titolo: impianto.plant_type || "Impianto",
  data: impianto.created_at,
  descrizione: `${impianto.brand || ""} ${impianto.model || ""}`.trim(),
})),

  ...interventiCliente.map((intervento) => ({
    id: `intervento-${intervento.id}`,
    tipo: "Intervento",
    titolo: intervento.intervention_type || "Intervento tecnico",
    data: intervento.intervention_date || intervento.created_at,
    descrizione:
      intervento.outcome ||
      intervento.notes ||
      intervento.technician_name ||
      "Intervento registrato sul cliente.",
  })),

  ...scadenzeCliente.map((scadenza) => ({
    id: `scadenza-${scadenza.id}`,
    tipo: "Verifica",
    titolo: scadenza.title || "Verifica tecnica",
    data: scadenza.due_date || scadenza.next_due_date || scadenza.created_at,
    descrizione:
      scadenza.notes ||
      scadenza.status ||
      "Scadenza tecnica collegata al cliente.",
  })),
].sort((a, b) => new Date(b.data || 0) - new Date(a.data || 0));

  if (vistaDettaglioCliente && clienteSelezionato) {
    return (
      <>
     <div style={{ marginBottom: "20px" }}> 
  <button
    onClick={() => {
      setVistaDettaglioCliente(false);
      setClienteSelezionato(null);

      setImpiantiCliente([]);
      setInterventiCliente([]);
      setScadenzeCliente([]);
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background = "#dbeafe";
      e.currentTarget.style.boxShadow =
        "0 4px 12px rgba(15,60,117,0.12)";
      e.currentTarget.style.transform = "translateY(-1px)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background = "#f1f5f9";
      e.currentTarget.style.boxShadow = "none";
      e.currentTarget.style.transform = "translateY(0)";
    }}
    style={{
      display: "inline-flex",
      width: "auto",
      alignItems: "center",
      justifyContent: "center",
      background: "#f1f5f9",
      color: "#0f3c75",
      border: "1px solid #dbe4f0",
      borderRadius: "10px",
      padding: "10px 18px",
      cursor: "pointer",
      fontWeight: 700,
      fontSize: "14px",
      transition: "all 0.2s ease",
    }}
  >
    ← Torna ai clienti
  </button>
</div> 

        <div
          style={{
            background: "#fff",
            borderRadius: "14px",
            padding: "22px",
            border: "1px solid #dbe4f0",
            boxShadow: "0 2px 8px rgba(15,60,117,0.06)",
          }}
        >
          <CustomerDetailHeader
  cliente={clienteSelezionato}
  onEditCustomer={() => {
    setClienteInModifica(clienteSelezionato);
    setMostraModificaCliente(true);
    setVistaDettaglioCliente(false);
  }}
  onNewPlant={() => {
    setImpiantoDaAprireId(null);
    setSezione("impianti");
  }}
            primaryButtonStyle={{
              backgroundColor: "#0f3c75",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              padding: "10px 14px",
              fontWeight: 600,
              cursor: "pointer",
              fontSize: "14px",
            }}
            secondaryButtonStyle={{
              background: "#e2e8f0",
              border: "none",
              borderRadius: "8px",
              padding: "10px 14px",
              cursor: "pointer",
              fontWeight: 600,
            }}
          />

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "1.2fr 1fr",
              gap: "22px",
            }}
          >
            <div>
              <h2
                style={{
                  color: "#173a63",
                  fontSize: "22px",
                  margin: 0,
                }}
              >
                Dati cliente
              </h2>

              <div
                style={{
                  marginTop: "14px",
                  display: "grid",
                  gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
                  gap: "12px 18px",
                }}
              >
                <div>
                  <strong>Indirizzo:</strong>{" "}
                  {clienteSelezionato.address || "—"}
                </div>

                <div>
                  <strong>Provincia:</strong>{" "}
                  {clienteSelezionato.province || "—"}
                </div>

                <div>
                  <strong>Partita IVA:</strong>{" "}
                  {clienteSelezionato.vat_number || "—"}
                </div>

                <div>
                  <strong>Codice SDI:</strong>{" "}
                  {clienteSelezionato.sdi_code || "—"}
                </div>

                <div style={{ gridColumn: "1 / -1" }}>
                  <strong>Note:</strong>{" "}
                  {clienteSelezionato.notes || "—"}
                </div>
              </div>
            </div>

            <CustomerKpiPanel
  sectionTitleStyle={{
    color: "#173a63",
    fontSize: "22px",
    margin: 0,
  }}
  impiantiCliente={impiantiCliente}
  interventiCliente={interventiCliente}
  scadenzeCliente={scadenzeCliente}
/>
          </div>

          <div style={{ marginTop: "30px" }}>
            <CustomerTimeline
              cardStyle={{
                background: "#fff",
                borderRadius: "14px",
                padding: "22px",
                border: "1px solid #dbe4f0",
                boxShadow: "0 2px 8px rgba(15,60,117,0.06)",
              }}
              sectionTitleStyle={{
                color: "#173a63",
                fontSize: "22px",
                margin: 0,
              }}
              emptyBoxStyle={{
                border: "1px solid #dbe4f0",
                borderRadius: "12px",
                padding: "16px",
                backgroundColor: "#f8fbff",
                color: "#4b5563",
              }}
              timelineCliente={timelineCliente}
              formatDate={(value) =>
  value
    ? new Date(value).toLocaleDateString("it-IT")
    : "—"
}
onOpenPlant={(plantId) => {
  setOrigineAperturaImpianto("cliente");
  setImpiantoDaAprireId(plantId);
  setSezione("impianti");
}}
/>
          </div>

          <div style={{ marginTop: "30px" }}>
            <CustomerPlantsPanel
  cardStyle={{
    background: "#fff",
    borderRadius: "14px",
    padding: "22px",
    border: "1px solid #dbe4f0",
    boxShadow: "0 2px 8px rgba(15,60,117,0.06)",
  }}
  sectionTitleStyle={{
    color: "#173a63",
    fontSize: "22px",
    margin: 0,
  }}
  emptyBoxStyle={{
    border: "1px solid #dbe4f0",
    borderRadius: "12px",
    padding: "16px",
    backgroundColor: "#f8fbff",
    color: "#4b5563",
  }}
  impiantiCliente={impiantiCliente}
  onOpenPlant={(plantId) => {
  setOrigineAperturaImpianto("cliente");
  setImpiantoDaAprireId(plantId);
  setSezione("impianti");
}}
/>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "24px",
        }}
      >
        <div>
          <h1 style={pageTitleStyle}>Clienti</h1>

          <p style={pageSubtitleStyle}>
            Gestisci anagrafiche clienti, contatti e informazioni fiscali
          </p>
        </div>

        {utenteCorrente?.role !== "viewer" && (
  <button
    className="btn btn-primary"
    onClick={() => setMostraNuovoCliente(true)}
    style={{
      backgroundColor: "#0f3c75",
      color: "#fff",
      border: "none",
      borderRadius: "10px",
      padding: "12px 18px",
      fontSize: "15px",
      fontWeight: 600,
      cursor: "pointer",
    }}
  >
    + Nuovo cliente
  </button>
)}
      </div>

      {mostraNuovoCliente && (
  <div
    style={{
      background: "#fff",
      border: "1px solid #dbe4f0",
      borderRadius: "14px",
      padding: "24px",
      marginBottom: "24px",
      boxShadow: "0 2px 10px rgba(15,60,117,0.08)",
    }}
  >
    <h2
      style={{
        marginTop: 0,
        marginBottom: "20px",
        color: "#0f3c75",
      }}
    >
      Nuovo cliente
    </h2>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "16px",
      }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
  <label style={{ fontSize: "13px", fontWeight: 700, color: "#475569" }}>
    Nome / Denominazione
  </label>

  <input
    type="text"
    placeholder="Esempio: Mario oppure Scuola Primaria Verdi"
    value={nuovoCliente.first_name}
    onChange={(e) =>
      setNuovoCliente({
        ...nuovoCliente,
        first_name: e.target.value,
      })
    }
    style={inputStyle}
  />

  <div style={{ fontSize: "12px", color: "#64748b" }}>
    Per i privati inserisci il nome. Per aziende, enti o scuole inserisci la denominazione.
  </div>
</div>

    {nuovoCliente.customer_type === "privato" && (
  <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
    <label style={{ fontSize: "13px", fontWeight: 700, color: "#475569" }}>
      Cognome
    </label>

    <input
      type="text"
      placeholder="Esempio: Rossi"
      value={nuovoCliente.last_name}
      onChange={(e) =>
        setNuovoCliente({
          ...nuovoCliente,
          last_name: e.target.value,
        })
      }
      style={inputStyle}
    />

    <div style={{ fontSize: "12px", color: "#64748b" }}>
      Compilare solo per clienti privati.
    </div>
  </div>
)}  

      <select
  value={nuovoCliente.customer_type}
  onChange={(e) =>
    setNuovoCliente({
      ...nuovoCliente,
      customer_type: e.target.value,
    })
  }
  style={inputStyle}
>
  <option value="">Seleziona tipo cliente</option>
<option value="privato">Privato</option>
<option value="azienda">Azienda</option>
<option value="ente_pubblico">Ente pubblico</option>
<option value="condominio">Condominio</option>
<option value="hotel">Hotel</option>
<option value="industria">Industria</option>
<option value="studio_professionale">Studio professionale</option>
<option value="altro">Altro</option>
</select>

{nuovoCliente.customer_type === "ente_pubblico" && (
  <select
    value={nuovoCliente.customer_category || ""}
    onChange={(e) =>
      setNuovoCliente({
        ...nuovoCliente,
        customer_category: e.target.value,
      })
    }
    style={inputStyle}
  >
    <option value="">Tipologia ente (facoltativa)</option>
    <option value="Comune">Comune</option>
    <option value="Provincia">Provincia</option>
    <option value="Regione">Regione</option>
    <option value="Scuola">Scuola</option>
    <option value="Università">Università</option>
    <option value="Caserma">Caserma</option>
    <option value="Ospedale">Ospedale</option>
    <option value="ASL">ASL</option>
    <option value="Tribunale">Tribunale</option>
    <option value="Altro ente">Altro ente</option>
  </select>
)}

<input
  type="text"
  placeholder="Codice fiscale"
  value={nuovoCliente.fiscal_code || ""}
  onChange={(e) =>
    setNuovoCliente({
      ...nuovoCliente,
      fiscal_code: e.target.value,
    })
  }
  style={inputStyle}
/>

<input
  type="text"
  placeholder="Partita IVA"
  value={nuovoCliente.vat_number || ""}
  onChange={(e) =>
    setNuovoCliente({
      ...nuovoCliente,
      vat_number: e.target.value,
    })
  }
  style={inputStyle}
/>

<input
  type="email"
  placeholder="PEC"
  value={nuovoCliente.pec || ""}
  onChange={(e) =>
    setNuovoCliente({
      ...nuovoCliente,
      pec: e.target.value,
    })
  }
  style={inputStyle}
/>

<input
  type="text"
  placeholder="Codice SDI / Univoco"
  value={nuovoCliente.sdi_code || ""}
  onChange={(e) =>
    setNuovoCliente({
      ...nuovoCliente,
      sdi_code: e.target.value,
    })
  }
  style={inputStyle}
/>

      <input
        type="text"
        placeholder="Telefono"
        value={nuovoCliente.phone}
        onChange={(e) =>
          setNuovoCliente({
            ...nuovoCliente,
            phone: e.target.value,
          })
        }
        style={inputStyle}
      />

      <input
        type="email"
        placeholder="Email"
        value={nuovoCliente.email}
        onChange={(e) =>
          setNuovoCliente({
            ...nuovoCliente,
            email: e.target.value,
          })
        }
        style={inputStyle}
      />

      <input
        type="text"
        placeholder="Città"
        value={nuovoCliente.city}
        onChange={(e) =>
          setNuovoCliente({
            ...nuovoCliente,
            city: e.target.value,
          })
        }
        style={inputStyle}
      />

      <input
        type="text"
        placeholder="Provincia"
        value={nuovoCliente.province}
        onChange={(e) =>
          setNuovoCliente({
            ...nuovoCliente,
            province: e.target.value,
          })
        }
        style={inputStyle}
      />
    </div>

    <div
      style={{
        display: "flex",
        gap: "12px",
        marginTop: "24px",
      }}
    >
      <button
        className="btn btn-primary"
        onClick={salvaNuovoCliente}
        style={primaryButtonStyle}
      >
        Salva cliente
      </button>

      <button
        className="btn btn-secondary"
        onClick={() => setMostraNuovoCliente(false)}
        style={secondaryButtonStyle}
      >
        Annulla
      </button>
    </div>
  </div>
)}

{mostraModificaCliente && clienteInModifica && (
  <div
    style={{
      background: "#fff",
      border: "1px solid #dbe4f0",
      borderRadius: "14px",
      padding: "24px",
      marginBottom: "24px",
      boxShadow: "0 2px 10px rgba(15,60,117,0.08)",
    }}
  >
    <h2
      style={{
        marginTop: 0,
        marginBottom: "20px",
        color: "#0f3c75",
      }}
    >
      Modifica cliente
    </h2>

    <div
      style={{
        display: "grid",
        gridTemplateColumns: "repeat(2, 1fr)",
        gap: "16px",
      }}
    >
      <input
        type="text"
        placeholder="Nome"
        value={clienteInModifica.first_name || ""}
        onChange={(e) =>
          setClienteInModifica({
            ...clienteInModifica,
            first_name: e.target.value,
          })
        }
        style={inputStyle}
      />

      <input
        type="text"
        placeholder="Cognome"
        value={clienteInModifica.last_name || ""}
        onChange={(e) =>
          setClienteInModifica({
            ...clienteInModifica,
            last_name: e.target.value,
          })
        }
        style={inputStyle}
      />

      <select
  value={clienteInModifica.customer_type || ""}
  onChange={(e) =>
    setClienteInModifica({
      ...clienteInModifica,
      customer_type: e.target.value,
    })
  }
  style={inputStyle}
>
  <option value="">Seleziona tipo cliente</option>
  <option value="privato">Privato</option>
  <option value="azienda">Azienda</option>
  <option value="ente_pubblico">Ente pubblico</option>
  <option value="condominio">Condominio</option>
  <option value="hotel">Hotel</option>
  <option value="industria">Industria</option>
  <option value="studio_professionale">Studio professionale</option>
  <option value="altro">Altro</option>
</select>

{clienteInModifica.customer_type === "ente_pubblico" && (
  <select
    value={clienteInModifica.customer_category || ""}
    onChange={(e) =>
      setClienteInModifica({
        ...clienteInModifica,
        customer_category: e.target.value,
      })
    }
    style={inputStyle}
  >
    <option value="">Tipologia ente (facoltativa)</option>
    <option value="Comune">Comune</option>
    <option value="Provincia">Provincia</option>
    <option value="Regione">Regione</option>
    <option value="Scuola">Scuola</option>
    <option value="Università">Università</option>
    <option value="Caserma">Caserma</option>
    <option value="Ospedale">Ospedale</option>
    <option value="ASL">ASL</option>
    <option value="Tribunale">Tribunale</option>
    <option value="Altro ente">Altro ente</option>
  </select>
)}

<input
  type="text"
  placeholder="Codice fiscale"
  value={clienteInModifica.fiscal_code || ""}
  onChange={(e) =>
    setClienteInModifica({
      ...clienteInModifica,
      fiscal_code: e.target.value,
    })
  }
  style={inputStyle}
/>

<input
  type="text"
  placeholder="Partita IVA"
  value={clienteInModifica.vat_number || ""}
  onChange={(e) =>
    setClienteInModifica({
      ...clienteInModifica,
      vat_number: e.target.value,
    })
  }
  style={inputStyle}
/>

<input
  type="email"
  placeholder="PEC"
  value={clienteInModifica.pec || ""}
  onChange={(e) =>
    setClienteInModifica({
      ...clienteInModifica,
      pec: e.target.value,
    })
  }
  style={inputStyle}
/>

<input
  type="text"
  placeholder="Codice SDI / Univoco"
  value={clienteInModifica.sdi_code || ""}
  onChange={(e) =>
    setClienteInModifica({
      ...clienteInModifica,
      sdi_code: e.target.value,
    })
  }
  style={inputStyle}
/>

      <input
        type="text"
        placeholder="Telefono"
        value={clienteInModifica.phone || ""}
        onChange={(e) =>
          setClienteInModifica({
            ...clienteInModifica,
            phone: e.target.value,
          })
        }
        style={inputStyle}
      />

      <input
        type="email"
        placeholder="Email"
        value={clienteInModifica.email || ""}
        onChange={(e) =>
          setClienteInModifica({
            ...clienteInModifica,
            email: e.target.value,
          })
        }
        style={inputStyle}
      />

      <input
        type="text"
        placeholder="Città"
        value={clienteInModifica.city || ""}
        onChange={(e) =>
          setClienteInModifica({
            ...clienteInModifica,
            city: e.target.value,
          })
        }
        style={inputStyle}
      />

      <input
        type="text"
        placeholder="Provincia"
        value={clienteInModifica.province || ""}
        onChange={(e) =>
          setClienteInModifica({
            ...clienteInModifica,
            province: e.target.value,
          })
        }
        style={inputStyle}
      />
    </div>

    <div
      style={{
        display: "flex",
        gap: "12px",
        marginTop: "24px",
      }}
    >
      <button
  className="btn btn-primary"
  onClick={salvaModificaCliente}
  style={primaryButtonStyle}
>
  Salva modifiche
</button>

      <button
        className="btn btn-secondary"
        onClick={() => {
          setMostraModificaCliente(false);
          setClienteInModifica(null);
        }}
        style={secondaryButtonStyle}
      >
        Annulla
      </button>
    </div>
  </div>
)}

      <div
  style={{
    background: "#fff",
    borderRadius: "14px",
    padding: "20px",
    border: "1px solid #dbe4f0",
    boxShadow: "0 2px 8px rgba(15,60,117,0.06)",

    maxHeight: clienti.length > 10 ? "650px" : "none",
    overflowY: clienti.length > 10 ? "auto" : "visible",
  }}
>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
          }}
        >
          <thead>
            <tr
              style={{
                backgroundColor: "#f1f5f9",
                textAlign: "left",
              }}
            >
              <th
  style={{
    padding: "14px",
    position: "sticky",
    top: 0,
    backgroundColor: "#f1f5f9",
    zIndex: 2,
  }}
>
  Cliente
</th>

<th
  style={{
    padding: "14px",
    position: "sticky",
    top: 0,
    backgroundColor: "#f1f5f9",
    zIndex: 2,
  }}
>
  Telefono
</th>

<th
  style={{
    padding: "14px",
    position: "sticky",
    top: 0,
    backgroundColor: "#f1f5f9",
    zIndex: 2,
  }}
>
  Email
</th>

<th
  style={{
    padding: "14px",
    position: "sticky",
    top: 0,
    backgroundColor: "#f1f5f9",
    zIndex: 2,
  }}
>
  Tipo
</th>

<th
  style={{
    padding: "14px",
    position: "sticky",
    top: 0,
    backgroundColor: "#f1f5f9",
    zIndex: 2,
  }}
>
  Città
</th>

<th
  style={{
    padding: "14px",
    position: "sticky",
    top: 0,
    backgroundColor: "#f1f5f9",
    zIndex: 2,
  }}
>
  Azioni
</th>
            </tr>
          </thead>

          <tbody>
            {clienti.map((cliente) => (
              <tr
                key={cliente.id}
                style={{
                  borderTop: "1px solid #e2e8f0",
                }}
              >
                <td style={{ padding: "14px" }}>
                  {`${cliente.first_name || ""} ${cliente.last_name || ""}`.trim() ||
                    cliente.company_name ||
                    "-"}
                </td>

                <td style={{ padding: "14px" }}>
                  {cliente.phone || "-"}
                </td>

                <td style={{ padding: "14px" }}>
  {cliente.email || "-"}
</td>

<td style={{ padding: "14px" }}>
  {{
    privato: "Privato",
    azienda: "Azienda",
    ente_pubblico: "Ente pubblico",
    condominio: "Condominio",
    hotel: "Hotel",
    industria: "Industria",
    studio_professionale: "Studio professionale",
    altro: "Altro",
  }[cliente.customer_type] || "-"}
</td>

<td style={{ padding: "14px" }}>
  {cliente.city || "-"}
</td>

                <td style={{ padding: "14px" }}>
                  <button
  className="btn btn-secondary"
  onClick={() => apriSchedaCliente(cliente)}
  style={{
                      background: "#e2e8f0",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 12px",
                      cursor: "pointer",
                      marginRight: "8px",
                    }}
                  >
                    Apri
                  </button>

                  {!isViewer && (
  <button
    className="btn btn-secondary"
    onClick={() => apriModificaCliente(cliente)}
    style={{
      background: "#e2e8f0",
      border: "none",
      borderRadius: "8px",
      padding: "8px 12px",
      cursor: "pointer",
      marginRight: "8px",
    }}
  >
    Modifica
  </button>
)}

{isAdmin && (
  <button
    className="btn btn-danger"
    onClick={() => eliminaCliente(cliente.id)}
    style={{
      background: "#fee2e2",
      color: "#b91c1c",
      border: "none",
      borderRadius: "8px",
      padding: "8px 12px",
      cursor: "pointer",
    }}
  >
    Elimina
  </button>
)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

    if (sezione === "documenti_personali") {
      return renderDocumentiCategoria();
    }

    if (sezione === "casa_immobili") {
      return (
        <>
          <h1>Casa e immobili</h1>
          <p>Qui apriremo la maschera e la lista dei dati della categoria.</p>
        </>
      );
    }

    if (sezione === "protezione_personale_familiare") {
      return (
        <>
          <h1>Protezione personale e familiare</h1>
          <p>Qui apriremo la maschera e la lista dei dati della categoria.</p>
        </>
      );
    }

    if (sezione === "fisco_tributi") {
      return (
        <>
          <h1>Fisco e tributi</h1>
          <p>Qui apriremo la maschera e la lista dei dati della categoria.</p>
        </>
      );
    }

    if (sezione === "identita_digitale") {
      return (
        <>
          <h1>Identità digitale</h1>
          <p>Qui apriremo la maschera e la lista dei dati della categoria.</p>
        </>
      );
    }

    if (sezione === "previdenza_investimenti_debiti") {
      return (
        <>
          <h1>Previdenza Investimenti Debiti</h1>
          <p>Qui apriremo la maschera e la lista dei dati della categoria.</p>
        </>
      );
    }

    if (sezione === "salute_prevenzione") {
      return (
        <>
          <h1>Salute e prevenzione</h1>
          <p>Qui apriremo la maschera e la lista dei dati della categoria.</p>
        </>
      );
    }

    if (sezione === "mobilita") {
      return (
        <>
          <h1>Mobilità</h1>
          <p>Qui apriremo la maschera e la lista dei dati della categoria.</p>
        </>
      );
    }

    if (sezione === "animali_domestici") {
      return (
        <>
          <h1>Animali domestici</h1>
          <p>Qui apriremo la maschera e la lista dei dati della categoria.</p>
        </>
      );
    }

    if (sezione === "varie") {
      return (
        <>
          <h1>Varie</h1>
          <p>Qui apriremo la maschera e la lista dei dati della categoria.</p>
        </>
      );
    }

    if (sezione === "gestione_documenti") {
  const tabStyle = {
    padding: "12px 18px",
    borderRadius: "10px",
    border: "1px solid #cfd8e3",
    backgroundColor: "#f8fbff",
    cursor: "pointer",
    fontWeight: 600,
    color: "#173a63",
    transition: "all 0.18s ease",
  };

  const cardDocumentoStyle = {
  border: "1px solid #d6deea",
  borderRadius: "16px",
  padding: "22px",
  backgroundColor: "#ffffff",
  boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
  color: "#173a63",

  maxWidth: "700px",
  width: "100%",
  boxSizing: "border-box",
};

  const destinazioniAutomatiche = Object.keys(mappaCategorie);

const tipiDocumentoAutomatici = Array.from(
  new Set(
    [
      ...(nuovoDocumentoFile.destinazione
        ? elementiPerCategoria[nuovoDocumentoFile.destinazione] || []
        : []),

      ...(Array.isArray(documentiFile[utenteCorrente?.idUtente])
        ? documentiFile[utenteCorrente?.idUtente]
        : []
      )
        .filter(
          (doc) =>
            !nuovoDocumentoFile.destinazione ||
            doc.destinazione === nuovoDocumentoFile.destinazione
        )
        .map((doc) => doc.tipoDocumento),
    ]
      .filter(Boolean)
      .map((item) => item.trim())
  )
);

const tipiDocumentoSenzaAltro = tipiDocumentoAutomatici
  .filter((item) => item.toLowerCase() !== "altro")
  .sort();

const tipoAltro = tipiDocumentoAutomatici.find(
  (item) => item.toLowerCase() === "altro"
);

const tipiDocumentoFinali = tipoAltro
  ? [...tipiDocumentoSenzaAltro, tipoAltro]
  : tipiDocumentoSenzaAltro;

  const intestatariAutomatici = Array.from(
  new Set(
    [
      ...tuttiDocumenti.map((doc) => doc.intestatario),
      ...(Array.isArray(documentiFile[utenteCorrente?.idUtente])
        ? documentiFile[utenteCorrente?.idUtente]
        : []
      ).map((doc) => doc.intestatario),
    ].filter(Boolean)
  )
).sort();

  const handleSalvaDocumentoFile = () => {
    const tipoFinale =
      nuovoDocumentoFile.tipoDocumento === "Altro"
        ? nuovoDocumentoFile.tipoAltro.trim()
        : nuovoDocumentoFile.tipoDocumento;

    if (
  !nuovoDocumentoFile.intestatario.trim() ||
  !nuovoDocumentoFile.destinazione ||
  !tipoFinale ||
  !nuovoDocumentoFile.file
) {
      alert("Compila intestatario, tipologia documento e file.");
      return;
    }

const token = localStorage.getItem("token");

const formData = new FormData();
formData.append("file", nuovoDocumentoFile.file);
formData.append("intestatario", nuovoDocumentoFile.intestatario.trim());
formData.append("destinazione", nuovoDocumentoFile.destinazione);
formData.append("tipo_documento", tipoFinale);

if (nuovoDocumentoFile.scadenzaId) {
  formData.append("deadline_item_id", nuovoDocumentoFile.scadenzaId);
}

authFetch("/api/document-files/upload", {
  method: "POST",
  body: formData,
})
  .then((res) => {
    if (!res.ok) {
      throw new Error("Errore caricamento file");
    }
    return res.json();
  })
  .then((data) => {
    const nuovoFile = {
      id: data.id,
      scadenzaId: nuovoDocumentoFile.scadenzaId,
      intestatario: nuovoDocumentoFile.intestatario.trim(),
      destinazione: nuovoDocumentoFile.destinazione,
      tipoDocumento: tipoFinale,
      nomeFile: data.file_name,
      fileUrl: data.file_url,
      dataInserimento: new Date().toLocaleDateString("it-IT"),
    };

    setDocumentiFile((prev) => {
  const id = utenteCorrente?.idUtente;

  const listaPrecedente = Array.isArray(prev[id]) ? prev[id] : [];

  return {
    ...prev,
    [id]: [...listaPrecedente, nuovoFile],
  };
});

    setNuovoDocumentoFile({
      intestatario: "",
      destinazione: "",
      tipoDocumento: "",
      tipoAltro: "",
      file: null,
    });

    setFileInputKey(Date.now());
  })
  .catch((err) => {
    console.error("Errore upload file:", err);
    alert("Errore durante il caricamento del file.");
  });

return;
  };

  const lista = Array.isArray(documentiFile[utenteCorrente?.idUtente])
  ? documentiFile[utenteCorrente?.idUtente]
  : [];

const documentoFileSelezionato = lista.find(
  (doc) => String(doc.id) === String(documentoFileSelezionatoId)
);

const documentiFileFiltrati = lista.filter((doc) => {
  const ricerca = ricercaDocumentoFile.toLowerCase().trim();

    return (
      !ricerca ||
      doc.intestatario.toLowerCase().includes(ricerca) ||
      doc.tipoDocumento.toLowerCase().includes(ricerca) ||
      doc.nomeFile.toLowerCase().includes(ricerca)
    );
  });

  const FolderIconBlu = () => (
  <img
    src={cartellaBlu}
    alt="cartella"
    style={{
      width: "96px",
      height: "76px",
      objectFit: "contain",
      marginBottom: "14px",
      filter: "drop-shadow(0 10px 12px rgba(37, 99, 235, 0.22))",
      transition: "all 0.24s cubic-bezier(0.22, 1, 0.36, 1)",
    }}
  />
);


  const renderTabContent = () => {
    if (tabAttivoDocumenti === "inserisci") {
      return (
        <div style={cardDocumentoStyle}>
  <h2 style={{ ...pageTitleStyle, fontSize: "26px" }}>
    Inserisci documento
  </h2>

  <p
    style={{
      fontSize: "13px",
      color: "#64748b",
      marginTop: "4px",
      marginBottom: "16px",
    }}
  >
    * i campi contrassegnati con asterisco sono obbligatori
  </p>

          <p style={pageSubtitleStyle}>
            Carica un documento e associalo a intestatario, destinazione e tipologia.
          </p>

          <label style={labelStyle}>Intestatario *</label>
          <input
            style={inputStyle}
            type="text"
            placeholder="Es. Mario, Giusy, Martina..."
            value={nuovoDocumentoFile.intestatario}
            onChange={(e) =>
              setNuovoDocumentoFile((prev) => ({
                ...prev,
                intestatario: e.target.value,
              }))
            }
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
          />

          <label style={labelStyle}>Destinazione *</label>
<select
  style={inputStyle}
  value={nuovoDocumentoFile.destinazione}
  onChange={(e) =>
    setNuovoDocumentoFile((prev) => ({
      ...prev,
      destinazione: e.target.value,
      tipoDocumento: "",
      tipoAltro: "",
    }))
  }
  onFocus={handleInputFocus}
  onBlur={handleInputBlur}
>
  <option value="">Seleziona destinazione...</option>
  {destinazioniAutomatiche.map((destinazione) => (
    <option key={destinazione} value={destinazione}>
      {destinazione}
    </option>
  ))}
</select>

          <label style={labelStyle}>Tipologia documento *</label>
          <select
            style={inputStyle}
            value={nuovoDocumentoFile.tipoDocumento}
            onChange={(e) =>
              setNuovoDocumentoFile((prev) => ({
                ...prev,
                tipoDocumento: e.target.value,
                tipoAltro: e.target.value === "Altro" ? prev.tipoAltro : "",
              }))
            }
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
          >
            <option value="">Seleziona tipologia...</option>
            {tipiDocumentoFinali.map((tipo) => (
              <option key={tipo} value={tipo}>
                {tipo}
              </option>
            ))}
          </select>

          {nuovoDocumentoFile.tipoDocumento === "Altro" && (
            <>
              <label style={labelStyle}>Nuova tipologia documento *</label>
              <input
                style={inputStyle}
                type="text"
                placeholder="Scrivi nuova tipologia..."
                value={nuovoDocumentoFile.tipoAltro}
                onChange={(e) =>
                  setNuovoDocumentoFile((prev) => ({
                    ...prev,
                    tipoAltro: e.target.value,
                  }))
                }
                onFocus={handleInputFocus}
                onBlur={handleInputBlur}
              />
            </>
          )}

          <label style={labelStyle}>File documento *</label>
          <input
  key={fileInputKey}
  style={inputStyle}
  type="file"
  onChange={(e) =>
    setNuovoDocumentoFile((prev) => ({
      ...prev,
      file: e.target.files[0],
    }))
  }
  onFocus={handleInputFocus}
  onBlur={handleInputBlur}
/>

          <button
            style={primaryButtonStyle}
            onClick={handleSalvaDocumentoFile}
            onMouseEnter={handlePrimaryHover}
            onMouseLeave={handlePrimaryLeave}
            onMouseDown={handlePrimaryDown}
          >
            Salva documento
          </button>
        </div>
      );
    }

if (tabAttivoDocumenti === "elimina") {
  const lista = Array.isArray(documentiFile[utenteCorrente?.idUtente])
  ? documentiFile[utenteCorrente?.idUtente]
  : [];

  const documentiEliminabili = lista.filter((doc) => {
    if (eliminaModalita === "combinata") {
      return (
        (!eliminaDestinazione || doc.destinazione === eliminaDestinazione) &&
        (!eliminaIntestatario || doc.intestatario === eliminaIntestatario) &&
        (!eliminaTipologia || doc.tipoDocumento === eliminaTipologia)
      );
    }

    if (eliminaMetodo === "destinazione") {
      return doc.destinazione === eliminaDestinazione;
    }

    if (eliminaMetodo === "intestatario") {
      return doc.intestatario === eliminaIntestatario;
    }

    if (eliminaMetodo === "tipologia") {
      return doc.tipoDocumento === eliminaTipologia;
    }

    return false;
  });

  const resetEliminaDocumento = () => {
    setEliminaMetodo("");
    setEliminaDestinazione("");
    setEliminaIntestatario("");
    setEliminaTipologia("");
    setEliminaDocumentoId("");
  };

  return (
    <div style={cardDocumentoStyle}>
      <h2 style={{ ...pageTitleStyle, fontSize: "26px" }}>
        Elimina documento
      </h2>

      <p style={pageSubtitleStyle}>
        Seleziona uno o più criteri di ricerca, scegli il documento e rimuovilo
        dall’archivio.
      </p>

      <div style={{ marginBottom: "18px" }}>
        <label style={labelStyle}>Modalità ricerca</label>

        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
          <button
            style={{
              ...secondaryButtonStyle,
              backgroundColor:
                eliminaModalita === "singola" ? "#dbeafe" : "#f8f9fa",
              marginRight: 0,
            }}
            onClick={() => {
              setEliminaModalita("singola");
              resetEliminaDocumento();
            }}
            onMouseEnter={handleSecondaryHover}
            onMouseLeave={handleSecondaryLeave}
            onMouseDown={handleSecondaryDown}
          >
            Singola
          </button>

          <button
            style={{
              ...secondaryButtonStyle,
              backgroundColor:
                eliminaModalita === "combinata" ? "#dbeafe" : "#f8f9fa",
              marginRight: 0,
            }}
            onClick={() => {
              setEliminaModalita("combinata");
              resetEliminaDocumento();
            }}
            onMouseEnter={handleSecondaryHover}
            onMouseLeave={handleSecondaryLeave}
            onMouseDown={handleSecondaryDown}
          >
            Combinata
          </button>
        </div>
      </div>

      <label style={labelStyle}>Elimina per destinazione</label>
      <select
        style={inputStyle}
        value={eliminaDestinazione}
        onChange={(e) => {
          setEliminaMetodo("destinazione");
          setEliminaDestinazione(e.target.value);
          setEliminaDocumentoId("");

          if (eliminaModalita === "singola") {
            setEliminaIntestatario("");
            setEliminaTipologia("");
          }
        }}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
      >
        <option value="">Seleziona destinazione...</option>
        {destinazioniAutomatiche.map((destinazione) => (
          <option key={destinazione} value={destinazione}>
            {destinazione}
          </option>
        ))}
      </select>

      {eliminaModalita === "singola" && (
        <div
          style={{
            textAlign: "center",
            color: "#b45309",
            fontWeight: 600,
            margin: "8px 0 16px",
          }}
        >
          Oppure
        </div>
      )}

      <label style={labelStyle}>Elimina per intestatario</label>
      <select
        style={inputStyle}
        value={eliminaIntestatario}
        onChange={(e) => {
          setEliminaMetodo("intestatario");
          setEliminaIntestatario(e.target.value);
          setEliminaDocumentoId("");

          if (eliminaModalita === "singola") {
            setEliminaDestinazione("");
            setEliminaTipologia("");
          }
        }}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
      >
        <option value="">Seleziona intestatario...</option>
        {intestatariAutomatici.map((intestatario) => (
          <option key={intestatario} value={intestatario}>
            {intestatario}
          </option>
        ))}
      </select>

      {eliminaModalita === "singola" && (
        <div
          style={{
            textAlign: "center",
            color: "#b45309",
            fontWeight: 600,
            margin: "8px 0 16px",
          }}
        >
          Oppure
        </div>
      )}

      <label style={labelStyle}>Elimina per tipologia documento</label>
      <select
        style={inputStyle}
        value={eliminaTipologia}
        onChange={(e) => {
          setEliminaMetodo("tipologia");
          setEliminaTipologia(e.target.value);
          setEliminaDocumentoId("");

          if (eliminaModalita === "singola") {
            setEliminaDestinazione("");
            setEliminaIntestatario("");
          }
        }}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
      >
        <option value="">Seleziona tipologia...</option>
        {tipiDocumentoFinali.map((tipo) => (
          <option key={tipo} value={tipo}>
            {tipo}
          </option>
        ))}
      </select>

      <label style={labelStyle}>Documento da eliminare *</label>
      <select
        style={inputStyle}
        value={eliminaDocumentoId}
        onChange={(e) => setEliminaDocumentoId(e.target.value)}
        disabled={
          eliminaModalita === "singola"
            ? !eliminaMetodo
            : !eliminaDestinazione && !eliminaIntestatario && !eliminaTipologia
        }
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
      >
        <option value="">
          {eliminaModalita === "singola"
            ? eliminaMetodo
              ? "Seleziona documento..."
              : "Seleziona prima un criterio..."
            : eliminaDestinazione || eliminaIntestatario || eliminaTipologia
            ? "Seleziona documento..."
            : "Seleziona almeno un criterio..."}
        </option>

        {documentiEliminabili.map((doc) => (
          <option key={doc.id} value={doc.id}>
            {doc.destinazione} — {doc.intestatario} — {doc.tipoDocumento} —{" "}
            {doc.nomeFile}
          </option>
        ))}
      </select>

      <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
        <button
          style={dangerButtonStyle}
          onClick={() => {
            if (!eliminaDocumentoId) {
              alert("Seleziona prima un documento da eliminare.");
              return;
            }

            setDocumentiFile((prev) => {
  const id = utenteCorrente?.idUtente;

  return {
    ...prev,
    [id]: (prev[id] || []).filter(
      (doc) => String(doc.id) !== String(eliminaDocumentoId)
    ),
  };
});

resetEliminaDocumento();
          }}
          onMouseEnter={handleDangerHover}
          onMouseLeave={handleDangerLeave}
          onMouseDown={handleDangerDown}
        >
          Elimina
        </button>

        <button
          style={{ ...secondaryButtonStyle, marginRight: 0 }}
          onClick={resetEliminaDocumento}
          onMouseEnter={handleSecondaryHover}
          onMouseLeave={handleSecondaryLeave}
          onMouseDown={handleSecondaryDown}
        >
          Annulla
        </button>
      </div>
    </div>
  );
}

   if (tabAttivoDocumenti === "cerca") {
  const lista = Array.isArray(documentiFile[utenteCorrente?.idUtente])
  ? documentiFile[utenteCorrente?.idUtente]
  : [];

  const documentiCercati = lista.filter((doc) => {
    const ricerca = ricercaTestoDocumento.toLowerCase().trim();

    const matchTesto =
      !ricerca ||
      doc.destinazione?.toLowerCase().includes(ricerca) ||
      doc.intestatario?.toLowerCase().includes(ricerca) ||
      doc.tipoDocumento?.toLowerCase().includes(ricerca) ||
      doc.nomeFile?.toLowerCase().includes(ricerca);

    if (cercaModalita === "combinata") {
      return (
        matchTesto &&
        (!cercaDestinazione || doc.destinazione === cercaDestinazione) &&
        (!cercaIntestatario || doc.intestatario === cercaIntestatario) &&
        (!cercaTipologia || doc.tipoDocumento === cercaTipologia)
      );
    }

    if (cercaMetodo === "destinazione") {
      return matchTesto && doc.destinazione === cercaDestinazione;
    }

    if (cercaMetodo === "intestatario") {
      return matchTesto && doc.intestatario === cercaIntestatario;
    }

    if (cercaMetodo === "tipologia") {
      return matchTesto && doc.tipoDocumento === cercaTipologia;
    }

    return matchTesto;
  });

  const resetCercaDocumento = () => {
    setCercaMetodo("");
    setCercaDestinazione("");
    setCercaIntestatario("");
    setCercaTipologia("");
    setRicercaTestoDocumento("");
  };

  return (
    <div style={cardDocumentoStyle}>
      <h2 style={{ ...pageTitleStyle, fontSize: "26px" }}>
        Cerca documento
      </h2>

      <p style={pageSubtitleStyle}>
        Cerca un documento con modalità singola oppure combinando più criteri.
      </p>

      <div style={{ marginBottom: "18px" }}>
        <label style={labelStyle}>Modalità ricerca</label>

        <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
          <button
            style={{
              ...secondaryButtonStyle,
              backgroundColor:
                cercaModalita === "singola" ? "#dbeafe" : "#f8f9fa",
              marginRight: 0,
            }}
            onClick={() => {
              setCercaModalita("singola");
              resetCercaDocumento();
            }}
            onMouseEnter={handleSecondaryHover}
            onMouseLeave={handleSecondaryLeave}
            onMouseDown={handleSecondaryDown}
          >
            Singola
          </button>

          <button
            style={{
              ...secondaryButtonStyle,
              backgroundColor:
                cercaModalita === "combinata" ? "#dbeafe" : "#f8f9fa",
              marginRight: 0,
            }}
            onClick={() => {
              setCercaModalita("combinata");
              resetCercaDocumento();
            }}
            onMouseEnter={handleSecondaryHover}
            onMouseLeave={handleSecondaryLeave}
            onMouseDown={handleSecondaryDown}
          >
            Combinata
          </button>
        </div>
      </div>

      <label style={labelStyle}>Ricerca libera</label>
      <input
        style={inputStyle}
        type="text"
        placeholder="Cerca per nome file, intestatario, destinazione o tipologia..."
        value={ricercaTestoDocumento}
        onChange={(e) => setRicercaTestoDocumento(e.target.value)}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
      />

      <label style={labelStyle}>Cerca per destinazione</label>
      <select
        style={inputStyle}
        value={cercaDestinazione}
        onChange={(e) => {
          setCercaMetodo("destinazione");
          setCercaDestinazione(e.target.value);

          if (cercaModalita === "singola") {
            setCercaIntestatario("");
            setCercaTipologia("");
          }
        }}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
      >
        <option value="">Seleziona destinazione...</option>
        {destinazioniAutomatiche.map((destinazione) => (
          <option key={destinazione} value={destinazione}>
            {destinazione}
          </option>
        ))}
      </select>

      {cercaModalita === "singola" && (
        <div
          style={{
            textAlign: "center",
            color: "#b45309",
            fontWeight: 600,
            margin: "8px 0 16px",
          }}
        >
          Oppure
        </div>
      )}

      <label style={labelStyle}>Cerca per intestatario</label>
      <select
        style={inputStyle}
        value={cercaIntestatario}
        onChange={(e) => {
          setCercaMetodo("intestatario");
          setCercaIntestatario(e.target.value);

          if (cercaModalita === "singola") {
            setCercaDestinazione("");
            setCercaTipologia("");
          }
        }}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
      >
        <option value="">Seleziona intestatario...</option>
        {intestatariAutomatici.map((intestatario) => (
          <option key={intestatario} value={intestatario}>
            {intestatario}
          </option>
        ))}
      </select>

      {cercaModalita === "singola" && (
        <div
          style={{
            textAlign: "center",
            color: "#b45309",
            fontWeight: 600,
            margin: "8px 0 16px",
          }}
        >
          Oppure
        </div>
      )}

      <label style={labelStyle}>Cerca per tipologia documento</label>
      <select
        style={inputStyle}
        value={cercaTipologia}
        onChange={(e) => {
          setCercaMetodo("tipologia");
          setCercaTipologia(e.target.value);

          if (cercaModalita === "singola") {
            setCercaDestinazione("");
            setCercaIntestatario("");
          }
        }}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
      >
        <option value="">Seleziona tipologia...</option>
        {tipiDocumentoFinali.map((tipo) => (
          <option key={tipo} value={tipo}>
            {tipo}
          </option>
        ))}
      </select>

      <div style={{ display: "flex", gap: "12px", flexWrap: "wrap", marginBottom: "18px" }}>
        <button
          style={{ ...secondaryButtonStyle, marginRight: 0 }}
          onClick={resetCercaDocumento}
          onMouseEnter={handleSecondaryHover}
          onMouseLeave={handleSecondaryLeave}
          onMouseDown={handleSecondaryDown}
        >
          Pulisci ricerca
        </button>
      </div>

      <div style={{ display: "grid", gap: "12px" }}>
        {documentiCercati.map((doc) => (
          <div
            key={doc.id}
            style={{
              border: "1px solid #d6deea",
              borderRadius: "12px",
              padding: "14px",
              backgroundColor: "#f8fbff",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              gap: "12px",
              flexWrap: "wrap",
            }}
          >
            <div>
              <strong style={{ color: "#173a63" }}>{doc.nomeFile}</strong>
              <div style={{ fontSize: "13px", color: "#475569", marginTop: "4px" }}>
                {doc.destinazione} — {doc.intestatario} — {doc.tipoDocumento} — inserito il{" "}
                {doc.dataInserimento}
              </div>
            </div>

            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>

  
<a
  href={`${doc.fileUrl}?token=${localStorage.getItem("token")}`}
  target="_blank"
  rel="noreferrer"
  style={{
    ...secondaryButtonStyle,
    textDecoration: "none",
    marginRight: 0,
  }}
  onMouseEnter={handleSecondaryHover}
  onMouseLeave={handleSecondaryLeave}
  onMouseDown={handleSecondaryDown}
>
  Apri
</a>

</div>

          </div>
        ))}

        {documentiCercati.length === 0 && (
          <div
            style={{
              border: "1px solid #d6deea",
              borderRadius: "12px",
              padding: "16px",
              backgroundColor: "#f8fbff",
              color: "#64748b",
            }}
          >
            Nessun documento trovato.
          </div>
        )}
      </div>
    </div>
  );
}

   if (tabAttivoDocumenti === "archivio") {
  const documentiArchivio = Array.isArray(documentiFile[utenteCorrente?.idUtente])
  ? documentiFile[utenteCorrente?.idUtente]
  : [];

  const getDocumentiFiltratiArchivio = () => {
    return documentiArchivio.filter((doc) => {
      const matchDestinazione =
        !archivioDestinazione || doc.destinazione === archivioDestinazione;

      const matchIntestatario =
        !archivioIntestatario || doc.intestatario === archivioIntestatario;

      const matchTipologia =
        !archivioTipologia || doc.tipoDocumento === archivioTipologia;

      return matchDestinazione && matchIntestatario && matchTipologia;
    });
  };

  const documentiFiltratiArchivio = getDocumentiFiltratiArchivio();

  const destinazioniArchivio = Array.from(
    new Set([
      ...Object.keys(mappaCategorie),
      ...documentiArchivio.map((doc) => doc.destinazione),
    ].filter(Boolean))
  ).sort();

  const intestatariArchivio = Array.from(
    new Set(
      documentiArchivio
        .filter((doc) => doc.destinazione === archivioDestinazione)
        .map((doc) => doc.intestatario)
        .filter(Boolean)
    )
  ).sort();

  const tipologieArchivio = Array.from(
    new Set(
      documentiArchivio
        .filter(
          (doc) =>
            doc.destinazione === archivioDestinazione &&
            doc.intestatario === archivioIntestatario
        )
        .map((doc) => doc.tipoDocumento)
        .filter(Boolean)
    )
  ).sort();

  const resetArchivio = () => {
    setArchivioDestinazione("");
    setArchivioIntestatario("");
    setArchivioTipologia("");
  };

  const tornaIndietroArchivio = () => {
    if (archivioTipologia) {
      setArchivioTipologia("");
      return;
    }

    if (archivioIntestatario) {
      setArchivioIntestatario("");
      return;
    }

    if (archivioDestinazione) {
      setArchivioDestinazione("");
    }
  };

  const cardCartellaStyle = {
  border: "1px solid #d6deea",
  borderRadius: "20px",
  padding: "24px 20px",
  background: "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)",
  boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
  cursor: "pointer",
  transition: "all 0.24s cubic-bezier(0.22, 1, 0.36, 1)",
  textAlign: "center",
  color: "#173a63",
  fontWeight: 700,
  minHeight: "152px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  overflow: "hidden",
};

  const renderConteggioArchivio = (tipo, valore) => {
    const count = documentiArchivio.filter((doc) => {
      if (tipo === "destinazione") return doc.destinazione === valore;

      if (tipo === "intestatario") {
        return (
          doc.destinazione === archivioDestinazione &&
          doc.intestatario === valore
        );
      }

      if (tipo === "tipologia") {
        return (
          doc.destinazione === archivioDestinazione &&
          doc.intestatario === archivioIntestatario &&
          doc.tipoDocumento === valore
        );
      }

      return false;
    }).length;

    return `${count} document${count === 1 ? "o" : "i"}`;
  };

  return (
    <div style={cardDocumentoStyle}>
      <h2 style={{ ...pageTitleStyle, fontSize: "26px" }}>
        Archivio documenti personali
      </h2>

      <p style={pageSubtitleStyle}>
        Naviga l’archivio come un file system: destinazione, intestatario,
        tipologia documento e infine file disponibili.
      </p>

      <div
        style={{
          border: "1px solid #d6deea",
          borderRadius: "14px",
          padding: "14px 16px",
          backgroundColor: "#f8fbff",
          marginBottom: "22px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap: "12px",
          flexWrap: "wrap",
        }}
      >
        <div style={{ color: "#173a63", fontWeight: 700 }}>
          Archivio
          {archivioDestinazione && ` > ${archivioDestinazione}`}
          {archivioIntestatario && ` > ${archivioIntestatario}`}
          {archivioTipologia && ` > ${archivioTipologia}`}
        </div>

        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
          {(archivioDestinazione || archivioIntestatario || archivioTipologia) && (
            <button
              style={{ ...secondaryButtonStyle, marginRight: 0 }}
              onClick={tornaIndietroArchivio}
              onMouseEnter={handleSecondaryHover}
              onMouseLeave={handleSecondaryLeave}
              onMouseDown={handleSecondaryDown}
            >
              Indietro
            </button>
          )}

          {(archivioDestinazione || archivioIntestatario || archivioTipologia) && (
            <button
              style={{ ...secondaryButtonStyle, marginRight: 0 }}
              onClick={resetArchivio}
              onMouseEnter={handleSecondaryHover}
              onMouseLeave={handleSecondaryLeave}
              onMouseDown={handleSecondaryDown}
            >
              Home archivio
            </button>
          )}
        </div>
      </div>

      {!archivioDestinazione && (
        <>
          <h3 style={{ color: "#173a63", marginBottom: "16px" }}>
            Cartelle per destinazione
          </h3>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: "18px",
            }}
          >
            {destinazioniArchivio.map((destinazione) => (
              <div
                key={destinazione}
                onClick={() => {
                  setArchivioDestinazione(destinazione);
                  setArchivioIntestatario("");
                  setArchivioTipologia("");
                }}
                style={cardCartellaStyle}
                onMouseEnter={(e) => {
  e.currentTarget.style.transform = "translateY(-7px) scale(1.035)";
  e.currentTarget.style.boxShadow =
    "0 18px 36px rgba(37, 99, 235, 0.24)";
  e.currentTarget.style.borderColor = "#3b82f6";
  e.currentTarget.style.background =
    "linear-gradient(180deg, #ffffff 0%, #eef5ff 100%)";
}}

onMouseLeave={(e) => {
  e.currentTarget.style.transform = "translateY(0) scale(1)";
  e.currentTarget.style.boxShadow =
    "0 4px 14px rgba(0,0,0,0.05)";
  e.currentTarget.style.borderColor = "#d6deea";
  e.currentTarget.style.background =
    "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)";
}}

onMouseDown={(e) => {
  e.currentTarget.style.transform = "translateY(-2px) scale(0.985)";
}}
              >
                <FolderIconBlu />
                <div>{destinazione}</div>
                <div style={{ fontSize: "12px", color: "#64748b", marginTop: "6px" }}>
                  {renderConteggioArchivio("destinazione", destinazione)}
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {archivioDestinazione && !archivioIntestatario && (
        <>
          <h3 style={{ color: "#173a63", marginBottom: "16px" }}>
            Intestatari in {archivioDestinazione}
          </h3>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: "18px",
            }}
          >
            {intestatariArchivio.map((intestatario) => (
              <div
                key={intestatario}
                onClick={() => {
                  setArchivioIntestatario(intestatario);
                  setArchivioTipologia("");
                }}
                style={cardCartellaStyle}
                onMouseEnter={(e) => {
  e.currentTarget.style.transform = "translateY(-7px) scale(1.035)";
  e.currentTarget.style.boxShadow =
    "0 18px 36px rgba(37, 99, 235, 0.24)";
  e.currentTarget.style.borderColor = "#3b82f6";
  e.currentTarget.style.background =
    "linear-gradient(180deg, #ffffff 0%, #eef5ff 100%)";
}}

onMouseLeave={(e) => {
  e.currentTarget.style.transform = "translateY(0) scale(1)";
  e.currentTarget.style.boxShadow =
    "0 4px 14px rgba(0,0,0,0.05)";
  e.currentTarget.style.borderColor = "#d6deea";
  e.currentTarget.style.background =
    "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)";
}}

onMouseDown={(e) => {
  e.currentTarget.style.transform = "translateY(-2px) scale(0.985)";
}}
              >
                <FolderIconBlu />
                <div>{intestatario}</div>
                <div style={{ fontSize: "12px", color: "#64748b", marginTop: "6px" }}>
                  {renderConteggioArchivio("intestatario", intestatario)}
                </div>
              </div>
            ))}

            {intestatariArchivio.length === 0 && (
              <div
                style={{
                  border: "1px solid #d6deea",
                  borderRadius: "14px",
                  padding: "18px",
                  backgroundColor: "#f8fbff",
                  color: "#64748b",
                }}
              >
                Nessun intestatario presente in questa destinazione.
              </div>
            )}
          </div>
        </>
      )}

      {archivioDestinazione && archivioIntestatario && !archivioTipologia && (
        <>
          <h3 style={{ color: "#173a63", marginBottom: "16px" }}>
            Tipologie documento di {archivioIntestatario}
          </h3>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: "18px",
            }}
          >
            {tipologieArchivio.map((tipologia) => (
              <div
                key={tipologia}
                onClick={() => setArchivioTipologia(tipologia)}
                style={cardCartellaStyle}
                onMouseEnter={(e) => {
  e.currentTarget.style.transform = "translateY(-7px) scale(1.035)";
  e.currentTarget.style.boxShadow =
    "0 18px 36px rgba(37, 99, 235, 0.24)";
  e.currentTarget.style.borderColor = "#3b82f6";
  e.currentTarget.style.background =
    "linear-gradient(180deg, #ffffff 0%, #eef5ff 100%)";
}}

onMouseLeave={(e) => {
  e.currentTarget.style.transform = "translateY(0) scale(1)";
  e.currentTarget.style.boxShadow =
    "0 4px 14px rgba(0,0,0,0.05)";
  e.currentTarget.style.borderColor = "#d6deea";
  e.currentTarget.style.background =
    "linear-gradient(180deg, #ffffff 0%, #f8fbff 100%)";
}}

onMouseDown={(e) => {
  e.currentTarget.style.transform = "translateY(-2px) scale(0.985)";
}}
              >
                <FolderIconBlu />
                <div>{tipologia}</div>
                <div style={{ fontSize: "12px", color: "#64748b", marginTop: "6px" }}>
                  {renderConteggioArchivio("tipologia", tipologia)}
                </div>
              </div>
            ))}

            {tipologieArchivio.length === 0 && (
              <div
                style={{
                  border: "1px solid #d6deea",
                  borderRadius: "14px",
                  padding: "18px",
                  backgroundColor: "#f8fbff",
                  color: "#64748b",
                }}
              >
                Nessuna tipologia presente per questo intestatario.
              </div>
            )}
          </div>
        </>
      )}

      {archivioDestinazione && archivioIntestatario && archivioTipologia && (
        <>
          <h3 style={{ color: "#173a63", marginBottom: "16px" }}>
            Documenti disponibili
          </h3>

          <div style={{ display: "grid", gap: "12px" }}>
            {documentiFiltratiArchivio.map((doc) => (
              <div
                key={doc.id}
                style={{
                  border: "1px solid #d6deea",
                  borderRadius: "12px",
                  padding: "14px",
                  backgroundColor: "#f8fbff",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "12px",
                  flexWrap: "wrap",
                }}
              >
                <div>
                  <strong style={{ color: "#173a63" }}>{doc.nomeFile}</strong>
                  <div
                    style={{
                      fontSize: "13px",
                      color: "#475569",
                      marginTop: "4px",
                    }}
                  >
                    {doc.destinazione} — {doc.intestatario} — {doc.tipoDocumento}
                    {" "}— inserito il {doc.dataInserimento}
                  </div>
                </div>

                <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                 
                  <a
                    href={`${doc.fileUrl}?token=${localStorage.getItem("token")}`}
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      ...secondaryButtonStyle,
                      textDecoration: "none",
                      marginRight: 0,
                    }}
                    onMouseEnter={handleSecondaryHover}
                    onMouseLeave={handleSecondaryLeave}
                    onMouseDown={handleSecondaryDown}
                  >
                    Apri
                  </a>

                  </div>
              </div>
            ))}

            {documentiFiltratiArchivio.length === 0 && (
              <div
                style={{
                  border: "1px solid #d6deea",
                  borderRadius: "12px",
                  padding: "16px",
                  backgroundColor: "#f8fbff",
                  color: "#64748b",
                }}
              >
                Nessun documento presente in questa cartella.
              </div>
            )}
          </div>
        </>
      )}
    </div>
  );
} 

    return null;
  };

  return (
    <>
      <h1 style={pageTitleStyle}>
        Gestione documenti scadenzario familiare
      </h1>

      <p style={pageSubtitleStyle}>
        Archivio centralizzato per documenti, allegati e gestione documentale
      </p>

      <div
        style={{
          display: "flex",
          gap: "12px",
          marginTop: "20px",
          marginBottom: "20px",
          flexWrap: "wrap",
        }}
      >
        {[
          { id: "inserisci", label: "Inserisci documento" },
          { id: "elimina", label: "Elimina documento" },
          { id: "cerca", label: "Cerca documento" },
          { id: "archivio", label: "Archivio documenti personali" },
        ].map((tab) => (
  <div
    key={tab.id}
    data-active={tabAttivoDocumenti === tab.id}
    onClick={() => setTabAttivoDocumenti(tab.id)}
    style={{
              ...tabStyle,
              backgroundColor:
                tabAttivoDocumenti === tab.id ? "#dbeafe" : "#f8fbff",
              borderColor:
                tabAttivoDocumenti === tab.id ? "#7da7dc" : "#cfd8e3",
            }}
           onMouseEnter={(e) => {
  e.currentTarget.style.transform = "translateY(-2px) scale(1.015)";
  e.currentTarget.style.boxShadow = "0 6px 14px rgba(37, 99, 235, 0.15)";
  e.currentTarget.style.borderColor = "#3b82f6";
  e.currentTarget.style.backgroundColor = "#eef5ff";
}}

onMouseLeave={(e) => {
  e.currentTarget.style.transform = "translateY(0) scale(1)";
  e.currentTarget.style.boxShadow = "none";
  e.currentTarget.style.borderColor =
    e.currentTarget.dataset.active === "true" ? "#3b82f6" : "#cfd8e3";
  e.currentTarget.style.backgroundColor =
    e.currentTarget.dataset.active === "true" ? "#dbeafe" : "#ffffff";
}}

onMouseDown={(e) => {
  e.currentTarget.style.transform = "translateY(0) scale(0.97)";
}}

onMouseUp={(e) => {
  e.currentTarget.style.transform = "translateY(-2px) scale(1.015)";
}}
          >
            {tab.label}
          </div>
        ))}
      </div>

      {renderTabContent()}
    </>
  );
}

if (sezione === "guida") {
  const guidaCardStyle = {
    border: "1px solid #d6deea",
    borderRadius: "16px",
    padding: "24px",
    marginBottom: "22px",
    backgroundColor: "#ffffff",
    boxShadow: "0 4px 14px rgba(0,0,0,0.05)",
    color: "#0f172a",
    lineHeight: "1.7",
  };

  const guidaBoxStyle = {
    backgroundColor: "#f8fbff",
    border: "1px solid #cfd8e3",
    borderRadius: "14px",
    padding: "18px",
    marginTop: "16px",
  };

  const guidaWarningBoxStyle = {
    backgroundColor: "#fff7ed",
    border: "1px solid #fed7aa",
    borderRadius: "14px",
    padding: "18px",
    marginTop: "16px",
  };

  const guidaDangerBoxStyle = {
    backgroundColor: "#fff1f2",
    border: "1px solid #fecdd3",
    borderRadius: "14px",
    padding: "18px",
    marginTop: "16px",
  };

  const guidaTitleStyle = {
    color: "#173a63",
    fontSize: "26px",
    fontWeight: 600,
    marginTop: 0,
    marginBottom: "14px",
  };

  const guidaSmallTitleStyle = {
    color: "#173a63",
    fontSize: "17px",
    fontWeight: 700,
    marginBottom: "8px",
  };

  const guidaIndexItems = [
  { id: "guida-1", label: "1. Introduzione a TermoIdroGest" },
  { id: "guida-2", label: "2. Dashboard operativa" },
  { id: "guida-2-dashboard", label: "2.1 Come leggere la Dashboard" },
  { id: "guida-3", label: "3. Gestione clienti" },
  { id: "guida-4", label: "4. Gestione impianti" },
  { id: "guida-5", label: "5. Gestione interventi" },
  { id: "guida-6", label: "6. Firma cliente e verbali PDF" },
  { id: "guida-7", label: "7. Invio email dei verbali" },
  { id: "guida-8", label: "8. Manutenzioni programmate" },
  { id: "guida-9", label: "9. Scadenze tecniche" },
  { id: "guida-10", label: "10. Documenti impianto" },
  { id: "guida-11", label: "11. Calendario operativo" },
  { id: "guida-12", label: "12. Notifiche operative" },
  { id: "guida-13", label: "13. Ruoli e permessi" },
  { id: "guida-14", label: "14. Buone pratiche operative" },
  { id: "guida-15", label: "15. Sicurezza e gestione dati" },
];

  const aggiornaIndiceGuidaAttivo = () => {
    let sezioneAttiva = "guida-1";

    guidaIndexItems.forEach((item) => {
      const section = document.getElementById(item.id);
      if (section) {
        const rect = section.getBoundingClientRect();

        if (rect.top <= 180) {
          sezioneAttiva = item.id;
        }
      }
    });

    document.querySelectorAll("[data-guida-tab]").forEach((tab) => {
      const isActive = tab.getAttribute("data-guida-tab") === sezioneAttiva;

      tab.style.backgroundColor = isActive ? "#dbeafe" : "#e7f0fb";
      tab.style.borderColor = isActive ? "#7da7dc" : "#c7d8ee";
      tab.style.boxShadow = isActive ? "0 4px 10px rgba(0,0,0,0.08)" : "none";
      tab.style.transform = isActive ? "translateY(-1px)" : "translateY(0)";
    });
  };

  const scrollToGuidaSection = (id) => {
  const section = document.getElementById(id);

  if (section) {
    section.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });

    setTimeout(aggiornaIndiceGuidaAttivo, 400);
  }
};

const stampaSoloGuida = () => {
  const guidaContent = document.getElementById("guida-print-area");

  if (!guidaContent) {
    window.print();
    return;
  }

  const printWindow = window.open("", "_blank", "width=1000,height=800");

  const today = new Date().toLocaleDateString("it-IT");

  printWindow.document.write(`
    <html>
      <head>
        <title>Manuale Operativo TermoIdroGest</title>

        <style>
          @page {
            size: A4;
            margin: 18mm;
          }

          body {
            font-family: Arial, sans-serif;
            color: #0f172a;
            background: #ffffff;
            line-height: 1.6;
            font-size: 12px;
          }

          h1, h2, h3 {
            color: #173a63;
          }

          h1 {
            font-size: 26px;
          }

          h2 {
            font-size: 20px;
            margin-top: 28px;
          }

          h3 {
            font-size: 15px;
          }

          button {
            display: none !important;
          }

          .print-cover {
            height: 92vh;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            page-break-after: always;
          }

          .print-cover-title {
            font-size: 34px;
            font-weight: 800;
            color: #173a63;
            margin-bottom: 14px;
          }

          .print-cover-subtitle {
            font-size: 18px;
            color: #475569;
            max-width: 680px;
            line-height: 1.6;
          }

          .print-cover-version {
            margin-top: 36px;
            color: #64748b;
            font-size: 13px;
          }

          .print-header {
            border-bottom: 2px solid #173a63;
            padding-bottom: 10px;
            margin-bottom: 22px;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }

          .print-header-title {
            color: #173a63;
            font-weight: 800;
            font-size: 16px;
          }

          .print-header-date {
            color: #64748b;
            font-size: 11px;
          }

          .print-footer {
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            border-top: 1px solid #cbd5e1;
            padding-top: 6px;
            font-size: 10px;
            color: #64748b;
            text-align: center;
          }

          [data-guida-tab] {
            break-inside: avoid;
          }

          div {
            box-sizing: border-box;
          }

          ul {
            margin-top: 6px;
          }

          li {
            margin-bottom: 4px;
          }
        </style>
      </head>

      <body>
        <div class="print-cover">
  <div class="print-cover-title">
    Manuale Operativo
    <br />
    <span style="color:#c1121f;">T</span>ermo
    <span style="color:#c1121f;">I</span>dro
    <span style="color:#c1121f;">G</span>est
  </div>

  <div
    style="
      margin-top:12px;
      font-size:16px;
      color:#64748b;
      max-width:700px;
      text-align:center;
      line-height:1.7;
    "
  >
    Sistema professionale per la gestione di impianti,
    manutenzioni programmate, verifiche tecniche,
    interventi operativi, documentazione e attività aziendali.
  </div>

  <div class="print-cover-subtitle">
    Guida completa alla lettura della Dashboard,
    alla gestione di clienti, impianti,
    interventi, manutenzioni programmate,
    verifiche tecniche, documenti e attività
    operative.
  </div>

  <div class="print-cover-version">
    Versione 1.0 · Data stampa: ${today}
  </div>
</div>

          <div class="print-cover-version">
            Versione 1.0 · Data stampa: ${today}
          </div>
        </div>

        <div class="print-header">
          <div class="print-header-title">
  <span style="color:#c1121f;">T</span>ermo
  <span style="color:#c1121f;">I</span>dro
  <span style="color:#c1121f;">G</span>est
  · Manuale Operativo
</div>

          <div class="print-header-date">
            Data stampa: ${today}
          </div>
        </div>

        ${guidaContent.innerHTML}

        <div class="print-footer">
  <strong>
    <span style="color:#c1121f;">T</span>ermo
    <span style="color:#c1121f;">I</span>dro
    <span style="color:#c1121f;">G</span>est
  </strong>
  · Manuale Operativo · Documento generato dalla webapp
</div>
      </body>
    </html>
  `);

  printWindow.document.close();
  printWindow.focus();

  setTimeout(() => {
    printWindow.print();
  }, 300);
};

return (
  <div
    id="guida-print-area"
    style={{ maxWidth: "1180px" }}
    onScroll={aggiornaIndiceGuidaAttivo}
  >
      <div
        style={{
          background: "linear-gradient(180deg, #3f7ee8 0%, #255dc6 100%)",
          color: "#ffffff",
          borderRadius: "22px",
          padding: "28px 38px",
          marginBottom: "24px",
          boxShadow: "0 8px 22px rgba(0,0,0,0.12)",
        }}
      >
        <div style={{ fontSize: "14px", fontWeight: 800, opacity: 0.9 }}>
          MANUALE OPERATIVO DELLA WEBAPP
        </div>

        <h1
  style={{
    fontSize: "36px",
    margin: "10px 0 14px",
    lineHeight: "1.15",
    fontWeight: 800,
  }}
>
  Manuale Operativo TermoIdroGest
</h1>

<p
  style={{
    fontSize: "18px",
    lineHeight: "1.7",
    maxWidth: "980px",
    marginBottom: "0",
  }}
>
  Questa guida descrive in modo chiaro e completo l’utilizzo di
  TermoIdroGest, la piattaforma per la gestione di clienti,
  impianti, interventi tecnici, manutenzioni programmate,
  verifiche periodiche, documenti impianto, calendario operativo
  e attività aziendali.
</p>

<div
  style={{
    display: "flex",
    gap: "12px",
    marginTop: "20px",
  }}
>
  <button
    onClick={stampaSoloGuida}
    style={{
      padding: "12px 20px",
      borderRadius: "12px",
      border: "none",
      background: "#ffffff",
      color: "#173a63",
      fontWeight: 700,
      fontSize: "14px",
      cursor: "pointer",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      transition: "all 0.2s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.transform = "translateY(-2px)";
      e.currentTarget.style.boxShadow =
        "0 6px 14px rgba(0,0,0,0.20)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.transform = "translateY(0)";
      e.currentTarget.style.boxShadow =
        "0 2px 8px rgba(0,0,0,0.15)";
    }}
  >
    🖨️ Stampa guida
  </button>

  <button
    onClick={stampaSoloGuida}
    style={{
      padding: "12px 20px",
      borderRadius: "12px",
      border: "1px solid rgba(255,255,255,0.4)",
      background: "rgba(255,255,255,0.15)",
      color: "#ffffff",
      fontWeight: 700,
      fontSize: "14px",
      cursor: "pointer",
      backdropFilter: "blur(4px)",
      transition: "all 0.2s ease",
    }}
    onMouseEnter={(e) => {
      e.currentTarget.style.background =
        "rgba(255,255,255,0.25)";
    }}
    onMouseLeave={(e) => {
      e.currentTarget.style.background =
        "rgba(255,255,255,0.15)";
    }}
  >
    📄 Esporta PDF
  </button>
</div>

</div>

<div
  style={{
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gap: "16px",
    marginBottom: "24px",
  }}
>
      <div style={guidaCardStyle}>
  <div style={guidaSmallTitleStyle}>Clienti e impianti</div>
  Gestisci anagrafiche clienti, impianti installati e informazioni tecniche in un unico ambiente.
</div>

<div style={guidaCardStyle}>
  <div style={guidaSmallTitleStyle}>Interventi tecnici</div>
  Registra interventi, firme cliente, verbali PDF e invio email direttamente dalla piattaforma.
</div>

<div style={guidaCardStyle}>
  <div style={guidaSmallTitleStyle}>Manutenzioni e verifiche</div>
  Controlla manutenzioni programmate, scadenze tecniche e rinnovi automatici.
</div>

<div style={guidaCardStyle}>
  <div style={guidaSmallTitleStyle}>Documenti impianto</div>
  Archivia libretti, certificazioni, rapporti tecnici e documenti collegati agli impianti.
</div>  
      </div>

    
  <h2 style={guidaTitleStyle}>Indice rapido</h2>
<div style={guidaCardStyle}>
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
            gap: "12px",
            marginTop: "14px",
          }}
        >
  {guidaIndexItems.map((item) => (
  <div
    key={item.id}
    data-guida-tab={item.id}
    onClick={() => scrollToGuidaSection(item.id)}
    style={{
      position: "relative",
      backgroundColor: "#e7f0fb",
      border: "1px solid #c7d8ee",
      borderLeft: "5px solid transparent",
      borderRadius: "12px",
      padding: "14px 16px",
      color: "#173a63",
      fontWeight: 700,
      cursor: "pointer",
      transition:
        "transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease, border-color 0.18s ease",
    }}
    onMouseEnter={(e) => {
  e.currentTarget.style.transform = "translateY(-2px) scale(1.015)";
  e.currentTarget.style.boxShadow = "0 6px 14px rgba(37, 99, 235, 0.15)";
  e.currentTarget.style.borderColor = "#3b82f6";
  e.currentTarget.style.backgroundColor = "#eef5ff";
}}

onMouseLeave={(e) => {
  e.currentTarget.style.transform = "translateY(0) scale(1)";
  e.currentTarget.style.boxShadow = "none";

  aggiornaIndiceGuidaAttivo();
}}

onMouseDown={(e) => {
  e.currentTarget.style.transform = "translateY(0) scale(0.97)";
}}

onMouseUp={(e) => {
  e.currentTarget.style.transform = "translateY(-2px) scale(1.015)";
}}
  >
    {item.label}
  </div>
))}
        </div>
      </div>

      <div id="guida-1" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>1. Introduzione a TermoIdroGest</h2>

  <p>
    TermoIdroGest è una piattaforma gestionale progettata per aziende,
    installatori e manutentori del settore termoidraulico.
  </p>

  <p>
    Il sistema consente di centralizzare la gestione di clienti,
    impianti, interventi tecnici, manutenzioni programmate,
    verifiche periodiche, documentazione tecnica e attività operative
    quotidiane in un unico ambiente semplice e organizzato.
  </p>

  <p>
    L'obiettivo della piattaforma è ridurre i tempi di gestione,
    migliorare il controllo delle attività e mantenere sempre
    aggiornate le informazioni tecniche relative agli impianti e ai
    clienti.
  </p>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Perché utilizzare TermoIdroGest</div>

    Invece di utilizzare fogli Excel, documenti cartacei,
    promemoria separati e archivi distribuiti, TermoIdroGest
    concentra tutte le informazioni operative in un'unica
    piattaforma accessibile e organizzata.
  </div>
</div>

   <div id="guida-2" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>2. Dashboard operativa</h2>

  <p>
    La Dashboard rappresenta il centro operativo di TermoIdroGest ed è
    progettata per fornire una panoramica immediata delle attività che
    richiedono attenzione.
  </p>

  <p>
    Attraverso gli indicatori operativi e il Centro notifiche è possibile
    individuare rapidamente manutenzioni, verifiche tecniche e attività
    da monitorare senza dover navigare tra le diverse sezioni del gestionale.
  </p>

  <ul>
    <li>
      <strong>Manutenzioni imminenti</strong>: attività in scadenza nel periodo monitorato.
    </li>

    <li>
      <strong>Manutenzioni in ritardo</strong>: attività oltre la data prevista.
    </li>

    <li>
      <strong>Verifiche imminenti</strong>: controlli tecnici prossimi alla scadenza.
    </li>

    <li>
      <strong>Verifiche in ritardo</strong>: verifiche tecniche già oltre la data prevista.
    </li>

    <li>
      <strong>Centro notifiche operative</strong>: raccolta centralizzata di tutte le notifiche generate automaticamente dal sistema.
    </li>

    <li>
      <strong>Filtri rapidi</strong>: visualizzazione immediata delle sole attività di interesse.
    </li>

    <li>
      <strong>Accesso diretto agli impianti</strong>: apertura immediata delle schede impianto collegate alle notifiche.
    </li>
  </ul>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>
      Utilizzo consigliato
    </div>

    La Dashboard dovrebbe essere consultata all'inizio di ogni giornata
    lavorativa per individuare attività imminenti, criticità operative e
    verifiche tecniche che richiedono attenzione.
  </div>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>
      Dashboard orientata alle attività
    </div>

    La Dashboard non è una semplice pagina statistica. Tutti gli indicatori
    presenti sono pensati per guidare l'operatore verso le attività che
    richiedono un'azione concreta, consentendo l'apertura immediata degli
    impianti interessati.
  </div>
</div>   

  <div id="guida-2-dashboard" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>2.1 Come leggere la Dashboard</h2>

  <p>
    La Dashboard rappresenta il centro operativo di TermoIdroGest.
    È progettata per mostrare immediatamente le attività che richiedono
    attenzione, le scadenze imminenti e le situazioni che necessitano
    di un intervento prioritario.
  </p>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>
      Obiettivo della Dashboard
    </div>

    La schermata iniziale consente di:
    <ul>
      <li>individuare rapidamente criticità operative;</li>
      <li>monitorare manutenzioni e verifiche tecniche;</li>
      <li>accedere direttamente agli impianti interessati;</li>
      <li>gestire le attività imminenti;</li>
      <li>controllare tutte le notifiche generate dal sistema.</li>
    </ul>
  </div>

  <h3 style={{ ...guidaSmallTitleStyle, marginTop: "18px" }}>
    Indicatori operativi (KPI)
  </h3>

  <p>
    Nella parte superiore della Dashboard sono presenti quattro indicatori
    operativi che mostrano la situazione attuale del gestionale.
  </p>

  <ul>
    <li>
      <strong>Manutenzioni imminenti</strong>:
      attività manutentive in scadenza entro il periodo monitorato.
    </li>

    <li>
      <strong>Manutenzioni in ritardo</strong>:
      manutenzioni oltre la data prevista.
    </li>

    <li>
      <strong>Verifiche imminenti</strong>:
      controlli e verifiche tecniche prossimi alla scadenza.
    </li>

    <li>
      <strong>Verifiche in ritardo</strong>:
      attività tecniche oltre la data prevista.
    </li>
  </ul>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>
      KPI e notifiche non rappresentano la stessa cosa
    </div>

    I KPI mostrano la situazione operativa attuale del gestionale.

    Le notifiche rappresentano invece tutti gli eventi generati
    nel periodo monitorato e possono quindi essere più numerose
    rispetto ai valori visualizzati negli indicatori operativi.
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>
      Accesso rapido dalle card
    </div>

    Ogni indicatore è cliccabile.

    Selezionando una card viene aperto automaticamente il
    Centro notifiche operative già filtrato sulla categoria
    corrispondente (manutenzioni, verifiche, criticità o attività
    da monitorare).
  </div>

  <h3 style={{ ...guidaSmallTitleStyle, marginTop: "18px" }}>
    Centro notifiche operative
  </h3>

  <p>
    Questa sezione raccoglie tutte le notifiche generate
    automaticamente dal sistema.
  </p>

  <ul>
    <li>manutenzioni imminenti;</li>
    <li>manutenzioni in ritardo;</li>
    <li>verifiche tecniche imminenti;</li>
    <li>verifiche tecniche in ritardo;</li>
    <li>attività da monitorare.</li>
  </ul>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>
      Filtri disponibili
    </div>

    Le notifiche possono essere filtrate tramite i pulsanti:

    <ul>
      <li>Tutte</li>
      <li>Critiche</li>
      <li>Da monitorare</li>
      <li>Manutenzioni</li>
      <li>Verifiche</li>
    </ul>

    Questo consente di concentrarsi rapidamente soltanto sulle
    attività di interesse.
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>
      Apertura diretta degli impianti
    </div>

    Ogni notifica contiene il pulsante
    <strong> Apri impianto</strong>,
    che permette di accedere immediatamente alla scheda
    dell'impianto interessato senza effettuare ricerche manuali.
  </div>

  <div style={guidaDangerBoxStyle}>
    <div style={guidaSmallTitleStyle}>
      Priorità operative
    </div>

    È consigliabile controllare quotidianamente:
    <ul>
      <li>manutenzioni in ritardo;</li>
      <li>verifiche tecniche in ritardo;</li>
      <li>attività imminenti nei prossimi giorni;</li>
      <li>notifiche critiche non ancora gestite.</li>
    </ul>
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>
      Utilizzo consigliato
    </div>

    All'inizio della giornata è consigliabile:
    <ol>
      <li>controllare i quattro indicatori operativi;</li>
      <li>aprire eventuali criticità presenti;</li>
      <li>consultare il Centro notifiche operative;</li>
      <li>aprire direttamente gli impianti da gestire.</li>
    </ol>
  </div>
</div>

   <div id="guida-3" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>3. Gestione clienti</h2>

  <p>
    La gestione dei clienti rappresenta il punto di partenza
    dell'organizzazione dei dati all'interno di TermoIdroGest.
  </p>

  <p>
    Ogni cliente può essere registrato tramite una scheda anagrafica
    contenente le principali informazioni necessarie alla gestione
    operativa e amministrativa delle attività.
  </p>

  <p>
    I clienti costituiscono il riferimento principale per la
    registrazione degli impianti e per la gestione degli interventi,
    delle manutenzioni e delle verifiche tecniche associate.
  </p>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Dati anagrafici</div>

    Per ogni cliente possono essere registrate informazioni quali:

    <ul>
      <li>Nome e cognome oppure ragione sociale</li>
      <li>Indirizzo</li>
      <li>Comune e provincia</li>
      <li>Recapiti telefonici</li>
      <li>Indirizzo email</li>
      <li>Note operative</li>
    </ul>
  </div>

  <h3 style={{ ...guidaSmallTitleStyle, marginTop: "18px" }}>
    Operazioni disponibili
  </h3>

  <ul>
    <li>
      <strong>Creazione cliente</strong>: inserimento di una nuova anagrafica.
    </li>

    <li>
      <strong>Modifica cliente</strong>: aggiornamento delle informazioni esistenti.
    </li>

    <li>
      <strong>Eliminazione cliente</strong>: rimozione dell'anagrafica dal sistema.
    </li>

    <li>
      <strong>Ricerca cliente</strong>: individuazione rapida delle anagrafiche registrate.
    </li>
  </ul>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Collegamento con gli impianti</div>

    Ogni cliente può avere uno o più impianti associati.
    Attraverso la scheda cliente è possibile consultare rapidamente
    le informazioni collegate agli impianti gestiti e alle relative
    attività operative.
  </div>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>Buona pratica</div>

    È consigliabile mantenere sempre aggiornati i dati anagrafici
    del cliente per garantire una corretta gestione degli interventi,
    della documentazione e delle comunicazioni.
  </div>
</div>   

      <div id="guida-4" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>4. Gestione impianti</h2>

  <p>
    Gli impianti rappresentano il nucleo operativo di TermoIdroGest.
    Ogni impianto viene associato a un cliente e costituisce il punto
    di riferimento per interventi, manutenzioni, verifiche tecniche e
    documentazione.
  </p>

  <p>
    La scheda impianto consente di raccogliere e consultare in modo
    centralizzato tutte le informazioni tecniche necessarie alla
    gestione dell'attività.
  </p>

  <p>I principali dati gestiti comprendono:</p>

  <ul>
    <li><strong>Tipologia impianto</strong></li>
    <li><strong>Marca</strong></li>
    <li><strong>Modello</strong></li>
    <li><strong>Matricola</strong></li>
    <li><strong>Ubicazione</strong></li>
    <li><strong>Data di installazione</strong></li>
    <li><strong>Note tecniche</strong></li>
  </ul>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Scheda impianto centralizzata</div>

    All'interno della scheda impianto sono raccolte tutte le
    informazioni operative collegate, permettendo una gestione
    ordinata e immediata delle attività.
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Funzioni disponibili</div>

    <ul>
      <li>Creazione di nuovi impianti</li>
      <li>Modifica delle informazioni tecniche</li>
      <li>Eliminazione impianti</li>
      <li>Consultazione dello storico operativo</li>
      <li>Gestione documentale dedicata</li>
      <li>Gestione interventi associati</li>
      <li>Gestione manutenzioni programmate</li>
      <li>Gestione verifiche e scadenze tecniche</li>
    </ul>
  </div>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>Buona pratica</div>

    È consigliabile compilare il maggior numero possibile di dati
    tecnici dell'impianto fin dal primo inserimento per facilitare
    le attività future di manutenzione, assistenza e consultazione
    documentale.
  </div>
</div>

      <div id="guida-5" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>5. Gestione interventi</h2>

  <p>
    La gestione degli interventi consente di registrare tutte le
    attività eseguite presso gli impianti dei clienti, mantenendo
    uno storico completo delle operazioni effettuate.
  </p>

  <p>
    Ogni intervento viene associato a uno specifico impianto e
    contiene le informazioni operative necessarie per documentare
    il lavoro svolto dal tecnico.
  </p>

  <p>I principali dati gestiti comprendono:</p>

  <ul>
    <li><strong>Titolo dell'intervento</strong></li>
    <li><strong>Data programmata</strong></li>
    <li><strong>Stato dell'intervento</strong></li>
    <li><strong>Descrizione delle attività svolte</strong></li>
    <li><strong>Note tecniche</strong></li>
    <li><strong>Firma del cliente</strong></li>
  </ul>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Operazioni disponibili</div>

    <ul>
      <li>Creazione di nuovi interventi</li>
      <li>Consultazione dello storico interventi</li>
      <li>Modifica delle informazioni registrate</li>
      <li>Eliminazione degli interventi</li>
      <li>Aggiornamento dello stato operativo</li>
    </ul>
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Stati disponibili</div>

    Gli interventi possono essere gestiti tramite gli stati:

    <ul>
      <li>Programmato</li>
      <li>Completato</li>
      <li>Annullato</li>
    </ul>
  </div>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>Storico operativo</div>

    Tutti gli interventi registrati rimangono associati all'impianto
    di riferimento, consentendo una consultazione rapida dello
    storico delle attività effettuate presso il cliente.
  </div>
</div>

      <div id="guida-6" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>6. Firma cliente e verbali PDF</h2>

  <p>
    TermoIdroGest consente di raccogliere la firma del cliente
    direttamente durante la compilazione dell'intervento,
    eliminando la necessità di documentazione cartacea separata.
  </p>

  <p>
    Al termine dell'attività il verbale può essere trasformato
    automaticamente in un documento PDF professionale,
    pronto per essere archiviato e condiviso.
  </p>

  <p>
    Questa funzionalità permette di mantenere una documentazione
    completa e facilmente consultabile per ogni impianto.
  </p>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Firma digitale del cliente</div>

    La firma viene acquisita direttamente all'interno della
    scheda intervento e viene associata al verbale generato,
    garantendo la tracciabilità dell'attività svolta.
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Generazione del verbale PDF</div>

    Il sistema genera automaticamente un verbale contenente:

    <ul>
      <li>Dati del cliente</li>
      <li>Dati dell'impianto</li>
      <li>Informazioni dell'intervento</li>
      <li>Attività eseguite</li>
      <li>Note operative</li>
      <li>Firma del cliente</li>
    </ul>
  </div>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>Archiviazione automatica</div>

    I verbali generati vengono conservati all'interno del sistema
    e rimangono collegati all'impianto di riferimento per una
    consultazione rapida dello storico documentale.
  </div>
</div>

    <div id="guida-7" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>7. Invio email dei verbali</h2>

  <p>
    Dopo la generazione del verbale PDF, TermoIdroGest consente
    l'invio diretto del documento tramite posta elettronica,
    semplificando la consegna della documentazione al cliente.
  </p>

  <p>
    Questa funzionalità elimina la necessità di scaricare il PDF,
    allegarlo manualmente a un messaggio e gestire l'invio tramite
    strumenti esterni.
  </p>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Invio rapido</div>

    Il verbale generato può essere inviato direttamente
    all'indirizzo email associato al cliente, riducendo i tempi
    di gestione amministrativa e migliorando la tracciabilità
    delle comunicazioni.
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Documentazione condivisa</div>

    Il cliente riceve una copia del verbale in formato PDF
    contenente tutte le informazioni dell'intervento eseguito,
    comprese le attività svolte e la firma raccolta.
  </div>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>Verifica dei dati</div>

    Prima dell'invio è consigliabile verificare che l'indirizzo
    email del cliente sia corretto e aggiornato all'interno
    dell'anagrafica.
  </div>
</div>  

      <div id="guida-8" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>8. Manutenzioni programmate</h2>

  <p>
    TermoIdroGest consente di pianificare e monitorare le
    manutenzioni periodiche associate agli impianti dei clienti.
  </p>

  <p>
    Ogni manutenzione viene collegata a uno specifico impianto e
    permette di programmare le attività future mantenendo sotto
    controllo le scadenze operative.
  </p>

  <p>I principali dati gestiti comprendono:</p>

  <ul>
    <li><strong>Titolo della manutenzione</strong></li>
    <li><strong>Data della prossima scadenza</strong></li>
    <li><strong>Periodicità</strong></li>
    <li><strong>Stato della manutenzione</strong></li>
    <li><strong>Note operative</strong></li>
  </ul>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Operazioni disponibili</div>

    <ul>
      <li>Creazione di nuove manutenzioni</li>
      <li>Modifica delle manutenzioni esistenti</li>
      <li>Eliminazione delle manutenzioni</li>
      <li>Completamento delle attività eseguite</li>
      <li>Consultazione dello storico operativo</li>
    </ul>
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Rigenerazione automatica</div>

    Quando una manutenzione viene completata, il sistema genera
    automaticamente la successiva scadenza in base alla periodicità
    impostata, evitando inserimenti manuali ripetitivi.
  </div>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>Controllo delle scadenze</div>

    È consigliabile verificare periodicamente le manutenzioni
    programmate per garantire il rispetto delle attività previste
    sugli impianti gestiti.
  </div>
</div>

     <div id="guida-9" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>9. Scadenze tecniche</h2>

  <p>
    Le scadenze tecniche consentono di gestire tutte le verifiche
    periodiche e gli adempimenti obbligatori associati agli impianti.
  </p>

  <p>
    Ogni scadenza viene collegata a uno specifico impianto e permette
    di monitorare nel tempo le attività che richiedono controlli,
    rinnovi o verifiche tecniche.
  </p>

  <p>I principali dati gestiti comprendono:</p>

  <ul>
    <li><strong>Titolo della verifica</strong></li>
    <li><strong>Data di scadenza</strong></li>
    <li><strong>Periodicità</strong></li>
    <li><strong>Stato della verifica</strong></li>
    <li><strong>Note tecniche</strong></li>
  </ul>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Operazioni disponibili</div>

    <ul>
      <li>Creazione di nuove verifiche tecniche</li>
      <li>Modifica delle verifiche esistenti</li>
      <li>Eliminazione delle verifiche</li>
      <li>Completamento delle attività eseguite</li>
      <li>Consultazione dello storico delle verifiche</li>
    </ul>
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Rinnovo automatico</div>

    Quando una verifica tecnica viene completata, il sistema genera
    automaticamente la successiva scadenza utilizzando la periodicità
    configurata, mantenendo aggiornato il piano delle verifiche.
  </div>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>Monitoraggio delle verifiche</div>

    Il controllo costante delle scadenze tecniche aiuta a mantenere
    gli impianti conformi alle verifiche previste e a programmare
    per tempo le attività necessarie.
  </div>
</div> 

     <div id="guida-10" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>10. Documenti impianto</h2>

  <p>
    La sezione Documenti Impianto consente di archiviare e gestire
    tutta la documentazione tecnica associata agli impianti presenti
    nel sistema.
  </p>

  <p>
    Ogni documento viene collegato a uno specifico impianto,
    permettendo una consultazione rapida e organizzata delle
    informazioni tecniche e amministrative.
  </p>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Documentazione gestibile</div>

    Tra i documenti che possono essere archiviati rientrano:

    <ul>
      <li>Libretti di impianto</li>
      <li>Certificazioni</li>
      <li>Dichiarazioni di conformità</li>
      <li>Rapporti di controllo</li>
      <li>Verbali di intervento</li>
      <li>Documentazione tecnica</li>
      <li>Allegati personalizzati</li>
    </ul>
  </div>

  <h3 style={{ ...guidaSmallTitleStyle, marginTop: "18px" }}>
    Operazioni disponibili
  </h3>

  <ul>
    <li><strong>Upload documenti</strong></li>
    <li><strong>Anteprima documenti</strong></li>
    <li><strong>Download documenti</strong></li>
    <li><strong>Eliminazione documenti</strong></li>
    <li><strong>Ricerca documenti</strong></li>
    <li><strong>Ordinamento archivio</strong></li>
    <li><strong>Gestione categorie</strong></li>
  </ul>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Archivio centralizzato</div>

    Tutti i documenti vengono organizzati all'interno
    dell'impianto di riferimento, consentendo una gestione
    ordinata e una rapida consultazione dello storico documentale.
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Scadenze automatiche</div>

    Quando previsto dalla tipologia di documento caricata,
    il sistema può generare automaticamente le relative
    scadenze tecniche, semplificando il monitoraggio delle
    verifiche future.
  </div>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>Buona pratica</div>

    È consigliabile archiviare tutta la documentazione tecnica
    direttamente all'interno dell'impianto di riferimento,
    mantenendo così uno storico completo e facilmente consultabile.
  </div>
</div> 

<div id="guida-11" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>11. Calendario operativo</h2>

  <p>
    Il Calendario Operativo consente di visualizzare in un'unica
    schermata tutte le attività pianificate all'interno di
    TermoIdroGest.
  </p>

  <p>
    Il calendario raccoglie automaticamente gli eventi provenienti
    dagli interventi, dalle manutenzioni programmate e dalle
    scadenze tecniche registrate nel sistema.
  </p>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Eventi visualizzati</div>

    Nel calendario vengono mostrati:

    <ul>
      <li>Interventi programmati</li>
      <li>Manutenzioni programmate</li>
      <li>Verifiche e scadenze tecniche</li>
    </ul>
  </div>

  <h3 style={{ ...guidaSmallTitleStyle, marginTop: "18px" }}>
    Gestione delle attività
  </h3>

  <p>
    Le attività possono essere consultate direttamente nelle diverse
    viste del calendario per avere una pianificazione sempre aggiornata
    delle operazioni da svolgere.
  </p>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Drag & Drop</div>

    Gli eventi possono essere spostati direttamente nel calendario
    tramite trascinamento. La modifica viene salvata automaticamente
    e aggiorna le relative date all'interno del gestionale.
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Aggiornamento automatico</div>

    Ogni modifica effettuata su interventi, manutenzioni o verifiche
    tecniche viene automaticamente riflessa nel calendario operativo,
    mantenendo sempre allineata la pianificazione delle attività.
  </div>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>Uso consigliato</div>

    Il calendario rappresenta uno strumento utile per organizzare
    le attività giornaliere e monitorare rapidamente gli impegni
    programmati sui diversi impianti gestiti.
  </div>
</div>

    <div id="guida-12" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>12. Notifiche operative</h2>

  <p>
    TermoIdroGest include un sistema avanzato di notifiche operative
    progettato per monitorare automaticamente manutenzioni, verifiche
    tecniche e attività che richiedono attenzione.
  </p>

  <p>
    Le notifiche vengono generate automaticamente dal sistema sulla base
    delle date registrate sugli impianti e consentono di individuare
    rapidamente situazioni critiche, attività imminenti e adempimenti
    da pianificare.
  </p>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Tipologie di notifiche</div>

    Il sistema genera automaticamente notifiche per:

    <ul>
      <li>Manutenzioni imminenti</li>
      <li>Manutenzioni in ritardo</li>
      <li>Verifiche tecniche imminenti</li>
      <li>Verifiche tecniche in ritardo</li>
      <li>Attività da monitorare</li>
    </ul>
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Centro notifiche operative</div>

    Tutte le notifiche vengono raccolte all'interno del Centro notifiche
    operative presente nella Dashboard.

    Da questa sezione è possibile:

    <ul>
      <li>consultare tutte le notifiche generate;</li>
      <li>filtrare le notifiche per categoria;</li>
      <li>aprire direttamente l'impianto interessato;</li>
      <li>identificare rapidamente le attività prioritarie.</li>
    </ul>
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Filtri disponibili</div>

    Le notifiche possono essere filtrate tramite i pulsanti:

    <ul>
      <li>Tutte</li>
      <li>Critiche</li>
      <li>Da monitorare</li>
      <li>Manutenzioni</li>
      <li>Verifiche</li>
    </ul>

    Questo consente di concentrarsi rapidamente sulle sole attività di
    interesse.
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Campanella notifiche</div>

    Nella barra superiore della piattaforma è presente una campanella che
    mostra il numero delle notifiche non ancora lette.

    Aprendo il pannello notifiche è possibile:

    <ul>
      <li>visualizzare le notifiche non lette;</li>
      <li>aprire direttamente l'impianto collegato;</li>
      <li>segnare una notifica come letta;</li>
      <li>archiviare una notifica.</li>
    </ul>
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Periodo monitorato</div>

    Le notifiche vengono generate all'interno di una finestra temporale
    configurata dal sistema (attualmente 30 giorni).

    Per questo motivo il numero totale delle notifiche può risultare
    superiore ai valori mostrati negli indicatori operativi della
    Dashboard.
  </div>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>
      Differenza tra KPI e notifiche
    </div>

    Gli indicatori operativi (KPI) mostrano la situazione attuale degli
    impianti.

    Le notifiche rappresentano invece tutti gli eventi generati nel
    periodo monitorato e possono quindi essere più numerose rispetto ai
    valori visualizzati nei KPI.
  </div>

  <div style={guidaDangerBoxStyle}>
    <div style={guidaSmallTitleStyle}>
      Buona pratica operativa
    </div>

    È consigliabile controllare quotidianamente il Centro notifiche e la
    campanella delle notifiche, gestendo prima le attività classificate
    come critiche o in ritardo.
  </div>
</div>  

     <div id="guida-13" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>13. Ruoli e permessi</h2>

  <p>
    TermoIdroGest utilizza un sistema di ruoli per controllare
    l'accesso alle funzionalità della piattaforma e garantire
    una corretta gestione delle attività aziendali.
  </p>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Ruolo Admin</div>

    L'amministratore dispone dell'accesso completo al sistema e può:

    <ul>
      <li>Gestire clienti e impianti</li>
      <li>Gestire interventi</li>
      <li>Gestire manutenzioni</li>
      <li>Gestire verifiche tecniche</li>
      <li>Gestire documenti impianto</li>
      <li>Consultare il calendario operativo</li>
      <li>Eliminare record dal sistema</li>
      <li>Accedere a tutte le funzionalità disponibili</li>
    </ul>
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Ruolo Technician</div>

    Il tecnico può operare sugli impianti e sulle attività operative:

    <ul>
      <li>Visualizzare clienti e impianti</li>
      <li>Creare e modificare interventi</li>
      <li>Completare manutenzioni programmate</li>
      <li>Completare verifiche tecniche</li>
      <li>Raccogliere firme cliente</li>
      <li>Generare verbali PDF</li>
      <li>Inviare documentazione al cliente</li>
    </ul>
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Ruolo Viewer</div>

    Il ruolo Viewer dispone esclusivamente di permessi di consultazione.

    <ul>
      <li>Visualizzazione clienti</li>
      <li>Visualizzazione impianti</li>
      <li>Visualizzazione documenti</li>
      <li>Visualizzazione calendario</li>
      <li>Visualizzazione dashboard</li>
    </ul>

    Non può creare, modificare o eliminare dati.
  </div>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>Sicurezza operativa</div>

    L'utilizzo dei ruoli consente di limitare l'accesso alle
    funzionalità sensibili e di assegnare a ciascun operatore
    esclusivamente gli strumenti necessari al proprio lavoro.
  </div>
</div> 

      <div id="guida-14" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>14. Buone pratiche operative</h2>

  <p>
    Un utilizzo corretto e costante di TermoIdroGest consente di
    mantenere un archivio tecnico ordinato, ridurre il rischio di
    dimenticanze e migliorare l'organizzazione delle attività.
  </p>

  <ul>
    <li>Mantenere aggiornate le anagrafiche dei clienti</li>
    <li>Compilare in modo completo le schede impianto</li>
    <li>Registrare tutti gli interventi effettuati</li>
    <li>Archiviare i verbali e la documentazione tecnica</li>
    <li>Completare tempestivamente manutenzioni e verifiche</li>
    <li>Consultare regolarmente il calendario operativo</li>
    <li>Verificare periodicamente notifiche e scadenze</li>
    <li>Utilizzare correttamente i ruoli utente assegnati</li>
  </ul>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Organizzazione efficace</div>

    Una corretta gestione dei dati consente di ricostruire rapidamente
    lo storico degli impianti, delle attività eseguite e della
    documentazione associata.
  </div>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>Suggerimento operativo</div>

    È consigliabile aggiornare il gestionale contestualmente
    all'esecuzione delle attività, evitando accumuli di informazioni
    da registrare successivamente.
  </div>
</div>
        
     <div id="guida-15" style={guidaCardStyle}>
  <h2 style={guidaTitleStyle}>15. Sicurezza e gestione dati</h2>

  <p>
    TermoIdroGest è progettato per garantire una gestione affidabile
    e organizzata delle informazioni tecniche, operative e documentali
    associate ai clienti e agli impianti.
  </p>

  <p>
    Tutti i dati vengono gestiti tramite il sistema applicativo,
    consentendo una consultazione rapida e una maggiore continuità
    operativa nel tempo.
  </p>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Gestione centralizzata</div>

    Le informazioni relative a clienti, impianti, interventi,
    manutenzioni, verifiche tecniche e documentazione vengono
    organizzate in un unico ambiente gestionale, riducendo la
    dispersione dei dati e migliorando la tracciabilità delle attività.
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Archiviazione documentale</div>

    I documenti caricati all'interno della piattaforma rimangono
    associati agli impianti di riferimento, consentendo una
    consultazione ordinata dello storico tecnico e amministrativo.
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Integrità delle informazioni</div>

    Le operazioni di inserimento, modifica ed eliminazione vengono
    gestite dal sistema in modo controllato, mantenendo la coerenza
    tra i dati registrati e le attività operative collegate.
  </div>

  <div style={guidaWarningBoxStyle}>
    <div style={guidaSmallTitleStyle}>Buone pratiche di sicurezza</div>

    <ul>
      <li>Mantenere aggiornati i dati anagrafici e tecnici</li>
      <li>Verificare le informazioni prima del salvataggio</li>
      <li>Controllare con attenzione le eliminazioni di dati e documenti</li>
      <li>Utilizzare correttamente i ruoli assegnati agli utenti</li>
      <li>Archiviare la documentazione all'interno degli impianti corretti</li>
    </ul>
  </div>

  <div style={guidaBoxStyle}>
    <div style={guidaSmallTitleStyle}>Obiettivo della piattaforma</div>

    TermoIdroGest è stato progettato per semplificare la gestione
    quotidiana delle attività termoidrauliche, centralizzando dati,
    documenti e operazioni in un unico strumento di lavoro.
  </div>

  <div style={guidaDangerBoxStyle}>
    <div style={guidaSmallTitleStyle}>Responsabilità dell'operatore</div>

    Ogni utente è responsabile della correttezza delle informazioni
    inserite e delle operazioni effettuate all'interno della
    piattaforma. Una gestione accurata dei dati garantisce la qualità
    e l'affidabilità dell'intero sistema.
  </div>
</div>   
<button
  onClick={() => {
    const main = document.querySelector("main");

    if (main) {
      main.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }}
  title="Torna all'inizio"
  style={{
    position: "fixed",
    bottom: "25px",
    right: "25px",
    width: "52px",
    height: "52px",
    borderRadius: "50%",
    border: "none",
    background: "#173a63",
    color: "#ffffff",
    fontSize: "24px",
    fontWeight: 700,
    cursor: "pointer",
    boxShadow: "0 6px 16px rgba(0,0,0,0.20)",
    zIndex: 9999,
  }}
>
  ↑
</button>
    </div>
  );
}

if (sezione === "cambia_password") {
  const passwordCardStyle = {
    width: "100%",
    maxWidth: "760px",
    margin: "20px auto",
    border: "1px solid #d6deea",
    borderRadius: "16px",
    backgroundColor: "#ffffff",
    boxShadow: "0 10px 28px rgba(0,0,0,0.08)",
    overflow: "hidden",
    color: "#0f172a",
    fontFamily:
      'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  };

  const passwordHeaderStyle = {
    padding: "28px",
    backgroundColor: "#f8fbff",
    borderBottom: "1px solid #d6deea",
  };

  const passwordBodyStyle = {
    padding: "28px",
  };

  const passwordFooterStyle = {
    padding: "20px 28px 28px",
    borderTop: "1px solid #d6deea",
    backgroundColor: "#f8fbff",
    display: "flex",
    justifyContent: "center",
    gap: "14px",
    flexWrap: "wrap",
  };

  const passwordInputWrapStyle = {
    position: "relative",
    marginBottom: "22px",
  };

  const passwordInputStyle = {
    width: "100%",
    padding: "13px 48px 13px 16px",
    border: "1px solid #cfd8e3",
    borderRadius: "10px",
    fontSize: "15px",
    boxSizing: "border-box",
    outline: "none",
    backgroundColor: "#ffffff",
    color: "#0f172a",
  };

  const eyeButtonStyle = {
    position: "absolute",
    right: "14px",
    top: "50%",
    transform: "translateY(-50%)",
    border: "none",
    background: "transparent",
    cursor: "pointer",
    padding: 0,
    fontSize: "18px",
    color: "#0f172a",
  };

  function pulisciPassword() {
    setPasswordForm({
      attuale: "",
      nuova: "",
      conferma: "",
    });

    setMostraPassword({
      attuale: false,
      nuova: false,
      conferma: false,
    });
  }

  function salvaPassword() {
    if (!passwordForm.attuale || !passwordForm.nuova || !passwordForm.conferma) {
      alert("Compila tutti i campi password.");
      return;
    }

    if (passwordForm.nuova !== passwordForm.conferma) {
      alert("La nuova password e la conferma non coincidono.");
      return;
    }

    alert("Funzione cambio password da collegare al backend.");
    pulisciPassword();
  }

  return (
    <div style={passwordCardStyle}>
      <div style={passwordHeaderStyle}>
       <h1
  style={{
    margin: 0,
    fontSize: "26px",
    fontWeight: 600,
    color: "#1e3a5f",
    letterSpacing: "0.5px",
  }}
>
  Cambia password
</h1> 
      </div>

      <div style={passwordBodyStyle}>
        <p
          style={{
            marginTop: 0,
            marginBottom: "26px",
            fontSize: "18px",
            color: "#334155",
            lineHeight: "1.6",
          }}
        >
          Per motivi di sicurezza, puoi modificare la tua password in qualsiasi
          momento.
        </p>

        <label style={labelStyle}>Password attuale</label>
        <div style={passwordInputWrapStyle}>
          <input
            type={mostraPassword.attuale ? "text" : "password"}
            placeholder="Inserisci la password attuale"
            value={passwordForm.attuale}
            onChange={(e) =>
              setPasswordForm((prev) => ({
                ...prev,
                attuale: e.target.value,
              }))
            }
            style={passwordInputStyle}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
          />

          <button
            type="button"
            style={eyeButtonStyle}
            onClick={() =>
              setMostraPassword((prev) => ({
                ...prev,
                attuale: !prev.attuale,
              }))
            }
          >
            {mostraPassword.attuale ? "🙈" : "👁"}
          </button>
        </div>

        <label style={labelStyle}>Nuova password</label>
        <div style={passwordInputWrapStyle}>
          <input
            type={mostraPassword.nuova ? "text" : "password"}
            placeholder="Inserisci la nuova password"
            value={passwordForm.nuova}
            onChange={(e) =>
              setPasswordForm((prev) => ({
                ...prev,
                nuova: e.target.value,
              }))
            }
            style={passwordInputStyle}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
          />

          <button
            type="button"
            style={eyeButtonStyle}
            onClick={() =>
              setMostraPassword((prev) => ({
                ...prev,
                nuova: !prev.nuova,
              }))
            }
          >
            {mostraPassword.nuova ? "🙈" : "👁"}
          </button>
        </div>

        <label style={labelStyle}>Conferma nuova password</label>
        <div style={passwordInputWrapStyle}>
          <input
            type={mostraPassword.conferma ? "text" : "password"}
            placeholder="Ripeti la nuova password"
            value={passwordForm.conferma}
            onChange={(e) =>
              setPasswordForm((prev) => ({
                ...prev,
                conferma: e.target.value,
              }))
            }
            style={passwordInputStyle}
            onFocus={handleInputFocus}
            onBlur={handleInputBlur}
          />

          <button
            type="button"
            style={eyeButtonStyle}
            onClick={() =>
              setMostraPassword((prev) => ({
                ...prev,
                conferma: !prev.conferma,
              }))
            }
          >
            {mostraPassword.conferma ? "🙈" : "👁"}
          </button>
        </div>
      </div>

      <div style={passwordFooterStyle}>
        <button
          style={{
            ...secondaryButtonStyle,
            minWidth: "170px",
            marginRight: 0,
          }}
          onClick={() => setSezione("home")}
          onMouseEnter={handleSecondaryHover}
          onMouseLeave={handleSecondaryLeave}
          onMouseDown={handleSecondaryDown}
        >
          Indietro
        </button>

        <button
          style={{
            ...secondaryButtonStyle,
            minWidth: "170px",
            marginRight: 0,
          }}
          onClick={pulisciPassword}
          onMouseEnter={handleSecondaryHover}
          onMouseLeave={handleSecondaryLeave}
          onMouseDown={handleSecondaryDown}
        >
          Pulisci campi
        </button>

        <button
          style={{
            ...primaryButtonStyle,
            minWidth: "250px",
            justifyContent: "center",
          }}
          onClick={salvaPassword}
          onMouseEnter={handlePrimaryHover}
          onMouseLeave={handlePrimaryLeave}
          onMouseDown={handlePrimaryDown}
        >
          Salva nuova password
        </button>
      </div>
    </div>
  );
}

    return <h1>Sezione non trovata</h1>;
  }

const giorni = ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"];
const mesi = ["gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"];

const giornoHeader = giorni[now.getDay()];
const dataHeader = `${now.getDate()} ${mesi[now.getMonth()]} ${now.getFullYear()}`;
const oraHeader = now.toLocaleTimeString("it-IT", {
  hour: "2-digit",
  minute: "2-digit",
});

function handleLogout() {
  const conferma = window.confirm("Vuoi uscire dalla webapp?");
  if (!conferma) return;

  localStorage.removeItem("token");
  localStorage.removeItem("utenteCorrente");

  setUtenteCorrente(null);
  setLoginForm({ email: "", password: "" });

  setClienti([]);
  setClienteSelezionato(null);
  setVistaDettaglioCliente(false);
  setImpiantiCliente([]);
  setInterventiCliente([]);
  setScadenzeCliente([]);
  setNotifications([]);
  setSearchResults([]);
  setSearchQuery("");

  setSezione("login");
}

if (sezione === "login") {

  function handleLoginDemo() {
    const emailInserita = loginForm.email.trim().toLowerCase();
    const passwordInserita = loginForm.password.trim();

    if (!emailInserita || !passwordInserita) {
      alert("Inserisci email e password.");
      return;
    }

    // 🔥 CHIAMATA AL BACKEND
    fetch(
      `/api/auth/login?email=${emailInserita}&password=${passwordInserita}`,
      {
        method: "POST",
      }
    )
      .then(async (res) => {
        if (!res.ok) {
          throw new Error("Credenziali non valide");
        }

        return res.json();
      })
      .then((data) => {

  // 🧹 pulizia dati precedente utente
  setClienti([]);
  setClienteSelezionato(null);
  setVistaDettaglioCliente(false);
  setImpiantiCliente([]);
  setInterventiCliente([]);
  setScadenzeCliente([]);
  setNotifications([]);
  setSearchResults([]);
  setSearchQuery("");

  // 🔑 SALVO TOKEN
  localStorage.setItem("token", data.access_token);

  // 👤 SALVO UTENTE
  const utente = {
    idUtente: data.user_id,
    family_id: data.family_id,
    company_id: data.company_id,
    role: data.role,
    nome: data.nome,
    email: data.email,
  };

        localStorage.setItem(
          "utenteCorrente",
          JSON.stringify(utente)
        );

        setUtenteCorrente(utente);

        // 🚀 HOME
        setSezione("home");
      })
      .catch((err) => {
        alert(err.message);
      });
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        backgroundColor: "#f4f4f4",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "32px",
        fontFamily:
          'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "520px",
          backgroundColor: "#ffffff",
          border: "3px solid #3f73b6",
          borderRadius: "56px",
          padding: "42px 46px",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <img
  src={logoAingegnerIA}
  alt="logo"
  style={{ width: "520px", maxWidth: "90%" }}
/>
        </div>

        <div
          style={{
            height: "1px",
            backgroundColor: "#d6deea",
            marginBottom: "28px",
          }}
        />

        <h1 style={{ fontSize: "28px", fontWeight: 400 }}>
          Accedi alla tua Area riservata
        </h1>

        <div style={{ marginBottom: "18px" }}>
  <div
  style={{
    fontSize: "15px",
    fontWeight: 500,
    marginBottom: "6px",
    color: "#374151",
  }}
>
  Inserisci indirizzo email *
</div>

  <input
    type="email"
    placeholder="nome.cognome@azienda.it"
    value={loginForm.email}
    onChange={(e) =>
      setLoginForm({ ...loginForm, email: e.target.value })
    }
    style={{
  width: "100%",
  height: "52px",
  borderRadius: "8px",
  border: "1px solid #d6deea",
  padding: "0 44px 0 16px",
  fontSize: "15px",
  boxSizing: "border-box",   // 👈 AGGIUNGI QUESTO
}}
  />
</div>

        <div style={{ marginBottom: "26px" }}>
  <div
  style={{
    fontSize: "15px",
    fontWeight: 500,
    marginBottom: "6px",
    color: "#374151",
  }}
>
  Inserisci password *
</div>

  <div style={{ position: "relative" }}>
    <input
      type={mostraLoginPassword ? "text" : "password"}
      placeholder="Inserisci password"
      value={loginForm.password}
      onChange={(e) =>
        setLoginForm({ ...loginForm, password: e.target.value })
      }
      style={{
        width: "100%",
        height: "52px",
        borderRadius: "8px",
        border: "1px solid #d6deea",
        padding: "0 44px 0 12px",
        fontSize: "14px",
        boxSizing: "border-box",
      }}
    />

    <button
      type="button"
      onClick={() => setMostraLoginPassword(!mostraLoginPassword)}
      style={{
        position: "absolute",
        right: "12px",
        top: "50%",
        transform: "translateY(-50%)",
        background: "none",
        border: "none",
        cursor: "pointer",
        padding: 0,
        fontSize: "18px",
      }}
    >
      👁
    </button>
  </div>
</div>

        <button
  onClick={handleLoginDemo}
  style={{
    width: "100%",
    height: "52px",
    borderRadius: "10px",
    border: "none",
    background: "linear-gradient(90deg, #4a6fdc, #3b5fc0)",
    color: "#fff",
    fontSize: "18px",
    fontWeight: 500,
    cursor: "pointer",
    marginTop: "10px",
  }}
>
  Accedi
</button>

<div
  style={{
    marginTop: "18px",
    fontSize: "16px",
    color: "#1e1f20",
    lineHeight: "1.5",
  }}
>
  Se hai dimenticato nome utente e/o password, contatta per piacere il gestore della piattaforma.
</div>

</div>
</div>

  );
}

  return (
  <div
    style={{
      height: "100vh",
      overflow: "hidden",
      fontFamily: "Arial, sans-serif",
      backgroundColor: "#ffffff",
      display: "flex",
      flexDirection: "column",
    }}
  >

    <header
  style={{
    background: "#ffffff",
    borderBottom: "4px solid #1aa0d6",
    padding: "16px 18px",
    display: "flex",
    alignItems: "center",
    gap: "18px",
    flexWrap: "wrap",
  }}
>
  {/* LOGO */}
<div style={{ display: "flex", alignItems: "center", minWidth: "260px" }}>
  <img
    src={logoAingegnerIA}
    alt="logo"
    style={{
      height: "80px",
      objectFit: "contain",
      display: "block",
    }}
  />
</div>

  {/* TITOLO + RICERCA GLOBALE */}
<div
  style={{
    flex: 1,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    position: "relative",
    gap: "14px",
  }}
>
  <div
    style={{
      fontFamily:
        'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
      fontWeight: 700,
      color: "#0b3a66",
      letterSpacing: "1px",
      fontSize: "42px",
      lineHeight: "1",
      textAlign: "center",
    }}
  >
    <span style={{ color: "#c1121f" }}>T</span>ermo
    <span style={{ color: "#c1121f" }}>I</span>dro
    <span style={{ color: "#c1121f" }}>G</span>est
  </div>

  <div
    style={{
      width: "420px",
      position: "relative",
    }}
  >
    <input
      type="text"
      placeholder="Cerca clienti, impianti, documenti, verifiche..."
      value={searchQuery}
      onChange={(e) => handleGlobalSearch(e.target.value)}
      onFocus={() => setShowSearchResults(true)}
      style={{
        width: "100%",
        padding: "12px 16px",
        borderRadius: "12px",
        border: "1px solid #cbd5e1",
        fontSize: "14px",
        outline: "none",
        background: "#fff",
      }}
    />

    {showSearchResults && searchResults.length > 0 && (
      <div
        style={{
          position: "absolute",
          top: "52px",
          left: 0,
          right: 0,
          background: "#fff",
          border: "1px solid #dbe4f0",
          borderRadius: "12px",
          boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
          zIndex: 9999,
          overflow: "hidden",
        }}
      >
        {searchResults.map((result, index) => (
          <div
  key={index}
  onClick={async () => {
  setShowSearchResults(false);
  setSearchQuery("");

  if (result.plant_id) {
  setOrigineAperturaImpianto("ricerca");
  setImpiantoDaAprireId(result.plant_id);
  setSezione("impianti");
  return;
}

  if (result.customer_id) {
    const clienteTrovato = clienti.find(
      (cliente) => cliente.id === result.customer_id
    );

    if (clienteTrovato) {
      await apriSchedaCliente(clienteTrovato);
    }

    setSezione("clienti");
    return;
  }
}}
  style={{
    padding: "12px 14px",
    borderBottom: "1px solid #eef2f7",
    cursor: "pointer",
  }}
>
            <div
              style={{
                fontSize: "11px",
                fontWeight: 700,
                color: "#64748b",
                marginBottom: "4px",
                textTransform: "uppercase",
              }}
            >
              {result.label}
            </div>

            <div
              style={{
                fontWeight: 700,
                color: "#173a63",
                marginBottom: "3px",
              }}
            >
              {result.title}
            </div>

            <div
              style={{
                fontSize: "13px",
                color: "#64748b",
              }}
            >
              {result.subtitle}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
</div>

  <div style={{ marginLeft: "auto", display: "flex", gap: "16px", alignItems: "flex-start" }}>

 {/* TAB DATA ORA */}
<div
  style={{
    background: "#243B8D",
    color: "#fff",
    padding: "12px 16px",
    display: "flex",
    alignItems: "center",
    gap: "14px",
    minWidth: "280px",
  }}
>
  <img
    src={iconDataOra}
    alt=""
    style={{ width: "34px", height: "34px", objectFit: "contain" }}
  />

  <div style={{ lineHeight: "1.05", fontWeight: 600 }}>
  <div style={{ fontSize: "13px", fontWeight: 600 }}>
    {giornoHeader} {dataHeader}
  </div>
  <div style={{ fontSize: "12px", fontWeight: 500 }}>
    Ore {oraHeader}
  </div>
</div>
</div>

{/* TAB UTENTE */}
<div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
  <div
    style={{
      background: "#243B8D",
      color: "#fff",
      padding: "12px 16px",
      display: "flex",
      alignItems: "center",
      gap: "14px",
      minWidth: "260px",
    }}
  >
    <img
      src={iconProfilo}
      alt=""
      style={{ width: "34px", height: "34px", objectFit: "contain" }}
    />

    <div style={{ lineHeight: "1.05", fontWeight: 600 }}>
      <div style={{ fontSize: "12px", fontWeight: 600 }}>
  UTENTE
</div>
      <div style={{ fontSize: "14px", fontWeight: 500 }}>
  {utenteCorrente?.nome || "Utente"}
</div>
    </div>

    <div style={{ flex: 1 }} />

<div ref={notificationDropdownRef} style={{ position: "relative" }}>
  <button
    onClick={() => setShowNotifications(!showNotifications)}
    title="Notifiche"
    style={{
      background: "transparent",
      border: "none",
      cursor: "pointer",
      position: "relative",
      fontSize: "24px",
      color: "#fff",
      marginRight: "14px",
    }}
  >
    🔔

    {unreadNotifications.length > 0 && (
      <span
        style={{
          position: "absolute",
          top: "-6px",
          right: "-6px",
          background: "#dc2626",
          color: "#fff",
          borderRadius: "999px",
          minWidth: "20px",
          height: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "11px",
          fontWeight: 800,
          padding: "0 5px",
        }}
      >
        {unreadNotifications.length}
      </span>
    )}
  </button>

  {showNotifications && (
    <div
      style={{
        position: "absolute",
        top: "52px",
        right: 0,
        width: "390px",
        maxHeight: "460px",
        overflowY: "auto",
        background: "#fff",
        border: "1px solid #dbe4f0",
        borderRadius: "16px",
        boxShadow: "0 16px 40px rgba(0,0,0,0.18)",
        zIndex: 9999,
        padding: "14px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "12px",
          gap: "12px",
        }}
      >
        <div>
          <div
            style={{
              fontWeight: 800,
              color: "#173a63",
              fontSize: "16px",
            }}
          >
            Centro notifiche
          </div>

          <div
  style={{
    color:
      unreadNotifications.length === 0
        ? "#16a34a"
        : "#64748b",
    fontSize: "12px",
    marginTop: "3px",
    fontWeight:
      unreadNotifications.length === 0
        ? 700
        : 400,
  }}
>
  {notifications.length === 0 ? (
    "Nessuna notifica presente"
  ) : unreadNotifications.length === 0 ? (
    <>
      ✓ Tutte le notifiche sono state lette

      <br />

      <span
        style={{
          fontSize: "11px",
          color: "#94a3b8",
          fontWeight: 500,
        }}
      >
        {notifications.length} notific{
          notifications.length === 1 ? "a" : "he"
        } archiviat{
          notifications.length === 1 ? "a" : "e"
        } o gestit{
          notifications.length === 1 ? "a" : "e"
        }
      </span>
    </>
  ) : (
    `${unreadNotifications.length} non lette su ${notifications.length}`
  )}
</div>
        </div>

        <button
          onClick={() => setShowNotifications(false)}
          style={{
            background: "#f1f5f9",
            border: "1px solid #cbd5e1",
            borderRadius: "8px",
            padding: "6px 9px",
            cursor: "pointer",
            fontWeight: 700,
          }}
        >
          ✕
        </button>
      </div>

      {notifications.length === 0 ? (
        <div
          style={{
            color: "#64748b",
            fontSize: "14px",
            padding: "14px",
            background: "#f8fafc",
            borderRadius: "12px",
            border: "1px solid #e2e8f0",
          }}
        >
          Nessuna notifica operativa.
        </div>
      ) : (
        notifications.map((item, index) => {
          const isCritical =
            item.priority === "critical" || item.priority === "danger";

          const isRead = item.is_read;

          return (
            <div
  key={item.id || index}
  onClick={async (e) => {
  e.stopPropagation();

  if (!item.plant_id) return;

  await markNotificationAsRead(item.id);
  setShowNotifications(false);
  setImpiantoDaAprireId(item.plant_id);
  setSezione("impianti");
}}
  style={{
                border: isCritical
                  ? "1px solid #fecdd3"
                  : "1px solid #fde68a",
                borderRadius: "12px",
                padding: "12px",
                marginBottom: "10px",
                background: isRead
                  ? "#f8fafc"
                  : isCritical
                  ? "#fff1f2"
                  : "#fffbeb",
                opacity: isRead ? 0.78 : 1,
                cursor: item.plant_id ? "pointer" : "default",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: "8px",
                  alignItems: "flex-start",
                }}
              >
                <div
                  style={{
                    fontWeight: 800,
                    color: isCritical ? "#b91c1c" : "#92400e",
                    marginBottom: "6px",
                  }}
                >
                  {item.title}
                </div>

                <span
                  style={{
                    background: isCritical ? "#fee2e2" : "#fef3c7",
                    color: isCritical ? "#991b1b" : "#92400e",
                    borderRadius: "999px",
                    padding: "4px 8px",
                    fontSize: "11px",
                    fontWeight: 800,
                    whiteSpace: "nowrap",
                  }}
                >
                  {isCritical ? "Critica" : "Da monitorare"}
                </span>
              </div>

              <div
                style={{
                  color: "#475569",
                  fontSize: "14px",
                  lineHeight: "1.5",
                }}
              >
                {item.message}
              </div>

              <div
                style={{
                  marginTop: "8px",
                  fontSize: "12px",
                  color: "#64748b",
                }}
              >
                Data:{" "}
                {new Date(item.event_date || item.date).toLocaleDateString(
                  "it-IT"
                )}
              </div>

              <div
  style={{
    marginTop: "4px",
    fontSize: "12px",
    color: "#64748b",
  }}
>
  Impianto:{" "}
  {item.plant
    ? `${item.plant.plant_type || "Impianto"} ${item.plant.model || ""}`.trim()
    : `#${item.plant_id || "—"}`}
</div>

{item.plant?.brand && (
  <div
    style={{
      marginTop: "4px",
      fontSize: "12px",
      color: "#64748b",
    }}
  >
    Marca: {item.plant.brand}
  </div>
)}

{item.plant?.serial_number && (
  <div
    style={{
      marginTop: "4px",
      fontSize: "12px",
      color: "#64748b",
    }}
  >
    Matricola: {item.plant.serial_number}
  </div>
)}

              <div
                style={{
                  display: "flex",
                  gap: "8px",
                  marginTop: "10px",
                  flexWrap: "wrap",
                }}
              >
                {item.plant_id && (
                  <button
                    onClick={async (e) => {
                      e.stopPropagation();
                      await markNotificationAsRead(item.id);
                      setShowNotifications(false);
                      setImpiantoDaAprireId(item.plant_id);
                      setSezione("impianti");
                    }}
                    style={{
                      background: "#173a63",
                      color: "#fff",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 12px",
                      cursor: "pointer",
                      fontWeight: 700,
                    }}
                  >
                    Apri impianto
                  </button>
                )}

                {!isRead && (
                  <button
                    onClick={async (e) => {
                      e.stopPropagation();
                      await markNotificationAsRead(item.id);
                    }}
                    style={{
                      background: "#e2e8f0",
                      color: "#334155",
                      border: "none",
                      borderRadius: "8px",
                      padding: "8px 12px",
                      cursor: "pointer",
                      fontWeight: 700,
                    }}
                  >
                    Segna letta
                  </button>
                )}

                <button
                  onClick={async () => {
                    await archiveNotification(item.id);
                  }}
                  style={{
                    background: "#fff",
                    color: "#64748b",
                    border: "1px solid #cbd5e1",
                    borderRadius: "8px",
                    padding: "8px 12px",
                    cursor: "pointer",
                    fontWeight: 700,
                  }}
                >
                  Archivia
                </button>
              </div>
            </div>
          );
        })
      )}
    </div>
  )}
</div>

    <button
      onClick={handleLogout}
      title="Logout"
      style={{
        background: "transparent",
        border: "none",
        padding: 0,
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <img
        src={iconLogout}
        alt="logout"
        style={{ width: "34px", height: "34px", objectFit: "contain" }}
      />
    </button>
  </div>

  <div style={{ textAlign: "left" }}>
    <button
  onClick={() => setSezione("cambia_password")}
  style={{
    background: "none",
    border: "none",
    color: "#1f3f7a",   // 🔥 leggermente meno acceso
    fontWeight: 500,    // 🔥 più leggero (prima era 600+)
    fontSize: "15px",   // 🔥 dimensione corretta
    textDecoration: "underline",
    cursor: "pointer",
    padding: 0,
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif', // 🔥 allineato al resto
  }}
>
  Cambia password
</button>
  </div>
</div> 

</div>
</header>

    <div
      style={{
        display: "flex",
        flex: 1,
        minHeight: 0,
        overflow: "hidden",
      }}
    >
<aside
  style={{
    width: sidebarOpen ? "340px" : "86px",
    borderRight: "1px solid #d6deea",
    padding: sidebarOpen ? "20px" : "12px 10px",
    backgroundColor: "#f3f6fa",
    overflowY: "auto",
    overflowX: "hidden",
    height: "100%",
    minHeight: 0,
    scrollbarColor: "#cfd8e3 #f3f6fa",
    transition: "width 0.25s ease, padding 0.25s ease",
    boxSizing: "border-box",
    flexShrink: 0,
    fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  }}
>
  <h2
  style={{
    fontWeight: 300,
    fontSize: "32px",
    color: "#173a63",
    marginBottom: "18px",
    display: sidebarOpen ? "block" : "none",
    lineHeight: "1.2",
    letterSpacing: "0.5px",
  }}
>
  Piattaforma operativa
</h2>

  <div style={sectionTitleStyle}>Operatività</div>

  <button
    style={{
      ...getButtonStyle(sezione === "home", "home"),
      justifyContent: sidebarOpen ? "space-between" : "center",
      padding: sidebarOpen ? "10px 12px" : "10px",
    }}
    onMouseEnter={() => setHoveredButton("home")}
    onMouseLeave={() => setHoveredButton("")}
    onClick={() => {
      if (sezione !== "home") {
        setSezione("home");
        setVistaDashboardAttiva(false);
        setFiltroDashboard("");
        setFiltroStato("");
        setMostraFormDocumenti(false);
        setSidebarOpen(true);
        return;
      }

      setSidebarOpen(!sidebarOpen);
    }}
  >
    <div
      style={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        gap: sidebarOpen ? "12px" : "0px",
        justifyContent: sidebarOpen ? "flex-start" : "center",
      }}
    >
      {sidebarOpen ? (
        <>
          {iconeSidebar["Home"] && (
            <img
              src={iconeSidebar["Home"]}
              alt=""
              style={{
                width: "36px",
                height: "36px",
                objectFit: "contain",
                flexShrink: 0,
              }}
            />
          )}

          <span
            style={{
              display: "flex",
              alignItems: "center",
              lineHeight: "1.15",
              flex: 1,
              color: "#0f172a",
            }}
          >
            Home
          </span>

          <span
            style={{
              marginLeft: "auto",
              fontSize: "18px",
              fontWeight: 600,
              color: "#4b5563",
              lineHeight: 1,
            }}
          >
            ✕
          </span>
        </>
      ) : (
        <span
          style={{
            fontSize: "18px",
            fontWeight: 600,
            color: "#4b5563",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            lineHeight: 1,
          }}
        >
          ☰
        </span>
      )}
    </div>
  </button>

  <button
  style={getButtonStyle(sezione === "clienti", "clienti")}
  onMouseEnter={() => setHoveredButton("clienti")}
  onMouseLeave={() => setHoveredButton("")}
  onClick={() => setSezione("clienti")}
>
  {iconeSidebar["Clienti"] && (
    <img
      src={iconeSidebar["Clienti"]}
      alt=""
      style={{
        width: "36px",
        height: "36px",
        objectFit: "contain",
        flexShrink: 0,
      }}
    />
  )}

    {sidebarOpen && (
     <span
  style={{
    display: "flex",
    alignItems: "center",
    lineHeight: "1.2",
    flex: 1,
    whiteSpace: "normal",
    wordBreak: "break-word",
  }}
> 
        Clienti
      </span>
    )}

    {sidebarOpen && (
      <span
        style={{
          marginLeft: "auto",
          opacity: 0.55,
          fontSize: "18px",
          fontWeight: 600,
          color: "#4b5563",
          lineHeight: 1,
        }}
      >
        &gt;
      </span>
    )}
  </button>

  <button
    style={getButtonStyle(sezione === "impianti", "impianti")}
    onMouseEnter={() => setHoveredButton("impianti")}
    onMouseLeave={() => setHoveredButton("")}
    onClick={() => {
      setSezione("impianti");
      setCategoriaAttiva("");
      setVistaDashboardAttiva(false);
      setFiltroDashboard("");
      setFiltroStato("");
    }}
  >
    {iconeSidebar["Impianti"] && (
  <img
    src={iconeSidebar["Impianti"]}
    alt=""
    style={{
      width: "36px",
      height: "36px",
      objectFit: "contain",
      flexShrink: 0,
    }}
  />
)}
    {sidebarOpen && (
      <span
        style={{
          display: "flex",
          alignItems: "center",
          lineHeight: "1.2",
          flex: 1,
          whiteSpace: "normal",
          wordBreak: "break-word",
        }}
      >
        Impianti
      </span>
    )}

    {sidebarOpen && (
      <span
        style={{
          marginLeft: "auto",
          opacity: 0.55,
          fontSize: "18px",
          fontWeight: 600,
          color: "#4b5563",
          lineHeight: 1,
        }}
      >
        &gt;
      </span>
    )}
  </button>

  <button
  style={{
    ...getButtonStyle(sezione === "calendario", "calendario"),
    justifyContent: sidebarOpen ? "space-between" : "center",
    padding: sidebarOpen ? "10px 12px" : "10px",
  }}
  onMouseEnter={() => setHoveredButton("calendario")}
  onMouseLeave={() => setHoveredButton("")}
  onClick={() => {
    if (sezione !== "calendario") {
      setSezione("calendario");
      setSidebarOpen(true);
    }
  }}
>
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: sidebarOpen ? "12px" : "0px",
    }}
  >
    <span style={{ fontSize: "26px" }}>📅</span>

    {sidebarOpen && (
      <span
        style={{
          fontSize: "15px",
          fontWeight: 500,
        }}
      >
        Calendario
      </span>
    )}
  </div>

  {sidebarOpen && (
    <span
      style={{
        color: "#9ca3af",
        fontWeight: 700,
      }}
    >
      {">"}
    </span>
  )}
</button>

<button
  style={getButtonStyle(sezione === "statistiche", "statistiche")}
  onMouseEnter={() => setHoveredButton("statistiche")}
  onMouseLeave={() => setHoveredButton("")}
  onClick={() => setSezione("statistiche")}
>
  <span style={{ fontSize: "26px" }}>📊</span>

  {sidebarOpen && (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        lineHeight: "1.15",
        flex: 1,
      }}
    >
      Statistiche
    </span>
  )}

  {sidebarOpen && (
    <span
      style={{
        marginLeft: "auto",
        opacity: 0.55,
        fontSize: "18px",
        fontWeight: 600,
        color: "#4b5563",
        lineHeight: 1,
      }}
    >
      &gt;
    </span>
  )}
</button>
  
 <div style={sectionTitleStyle}>Supporto</div>

<button
  style={getButtonStyle(sezione === "guida", "guida")}
  onMouseEnter={() => setHoveredButton("guida")}
  onMouseLeave={() => setHoveredButton("")}
  onClick={() => setSezione("guida")}
>
  {iconeSidebar["Guida"] && (
    <img
      src={iconeSidebar["Guida"]}
      alt=""
      style={{
        width: "36px",
        height: "36px",
        objectFit: "contain",
        flexShrink: 0,
      }}
    />
  )}

  {sidebarOpen && (
    <span
      style={{
        display: "flex",
        alignItems: "center",
        lineHeight: "1.15",
        flex: 1,
      }}
    >
      Guida
    </span>
  )}

  {sidebarOpen && (
    <span
      style={{
        marginLeft: "auto",
        opacity: 0.55,
        fontSize: "18px",
        fontWeight: 600,
        color: "#4b5563",
        lineHeight: 1,
      }}
    >
      &gt;
    </span>
  )}
</button>
</aside>

<main
  style={{
    flex: 1,
    padding: "30px",
    height: "100%",
    minHeight: 0,
    boxSizing: "border-box",
    overflowY: "auto",
    overflowX: "hidden",
    scrollbarColor: "#cfd8e3 #ffffff",
    display: "flex",
    flexDirection: "column",
  }}
> 
  {renderContenuto()}

  {/* LOGO FOOTER */}
<div
  style={{
    marginTop: "auto",   // 🔥 QUESTA È LA CHIAVE
    display: "flex",
    justifyContent: "center",
    paddingTop: "40px",
    paddingBottom: "20px",
  }}
>
  
</div>
</main>

</div>

    </div>
  );
}

export default App;